(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[576],{

/***/ 76896:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/state-of-hiring",
      function () {
        return __webpack_require__(64378);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 73412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45847);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75339);
/* harmony import */ var _HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21646);






var HeadMetadata = function(param) {
    var title = param.title, url = param.url, _desc = param.desc, desc = _desc === void 0 ? "" : _desc, imgUrl = param.imgUrl, path = param.path, _indexable = param.indexable, indexable = _indexable === void 0 ? false : _indexable;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: desc || ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    imgUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: imgUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@getmanfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: desc || ""
                    }),
                    imgUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: imgUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: desc || ""
                    }),
                    imgUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: "https://www.getmanfred.com/og-image.jpg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "Get Manfred"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: locale
                    }),
                    url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:url",
                                content: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                                rel: "canonical",
                                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_4__/* .config.appUrl */ .v.appUrl).concat(url.langs["es"])
                            })
                        ]
                    }),
                    indexable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "robots",
                        content: "index,follow"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_3___default()), {
                id: "globalLDMetadata",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: '{\n          "@context": "https://schema.org",\n          "@type": "Organization",\n          "name": "Manfred",\n          "url": "https://www.getmanfred.com/",\n          "logo": "https://www.getmanfred.com/favicon.ico",\n          "description": "Plataforma de empleo para profesionales del sector tecnol\xf3gico.",\n          "sameAs": [\n            "https://twitter.com/getmanfred",\n            "https://www.linkedin.com/company/getmanfred/",\n            "https://github.com/getmanfred>"\n          ],\n          "contactPoint": [\n            {\n              "@type": "ContactPoint",\n              "email": "support@getmanfred.com",\n              "contactType": "customer service",\n              "availableLanguage": ["Spanish", "English"]\n            }\n          ],\n          "founder": {\n            "@type": "Person",\n            "name": "David Bonilla",\n            "url": "https://twitter.com/david_bonilla>"\n          },\n          "foundingDate": "2019",\n          "areaServed": "Worldwide",\n          "address": {\n            "@type": "PostalAddress",\n            "addressCountry": "ES",\n            "addressRegion": "Madrid",\n            "addressLocality": "Madrid"\n          },\n          "offers": {\n            "@type": "Service",\n            "name": "Plataforma de empleo para el sector tech",\n            "description": "Conectamos profesionales tecnol\xf3gicos con empresas mediante un enfoque centrado en la privacidad y la transparencia."\n          }\n        }'
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HeadMetadataLangAlternate__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                url: url,
                path: path
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadata);


/***/ }),

/***/ 21646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21428);
/* harmony import */ var utils_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75339);




var HeadMetadataLangAlternate = function(param) {
    var url = param.url, path = param.path;
    var getPath = function getPath(path, locale) {
        if (!path) {
            return "";
        }
        return "/".concat((0,services_multilingual_service__WEBPACK_IMPORTED_MODULE_3__/* .getTranslatedText */ .G)(path, locale));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: url && Object.keys(url.langs).map(function(key) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "alternate",
                hrefLang: key,
                href: "".concat(utils_config__WEBPACK_IMPORTED_MODULE_2__/* .config.appUrl */ .v.appUrl, "/").concat(key).concat(url.langs[key]).concat(getPath(path, key))
            }, key);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadataLangAlternate);


/***/ }),

/***/ 99655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cd": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.Cd; },
/* harmony export */   "XJ": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.XJ; },
/* harmony export */   "aC": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.aC; },
/* harmony export */   "by": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.by; },
/* harmony export */   "k8": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.k8; },
/* harmony export */   "nL": function() { return /* reexport safe */ _Typography_styled__WEBPACK_IMPORTED_MODULE_0__.nL; }
/* harmony export */ });
/* harmony import */ var _Typography_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90637);



/***/ }),

/***/ 90637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cd": function() { return /* binding */ Heading6; },
/* harmony export */   "XJ": function() { return /* binding */ Heading2; },
/* harmony export */   "aC": function() { return /* binding */ Heading3; },
/* harmony export */   "by": function() { return /* binding */ Heading5; },
/* harmony export */   "k8": function() { return /* binding */ Heading4; },
/* harmony export */   "nL": function() { return /* binding */ Heading1; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40286);
/* harmony import */ var _theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90408);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: calc(",
        " * -1);\n        left: 50%;\n        transform: translateX(-50%);\n        width: ",
        ";\n        height: ",
        ";\n        background-color: ",
        ";\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: ",
        ";\n      user-select: none;\n\n      &::before {\n        left: 0;\n        transform: translateX(0);\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        &::before {\n          width: ",
        ";\n          height: ",
        ";\n        }\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.17;\n  margin: 0;\n\n  ",
        "\n\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n\n    ",
        "\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: calc(",
        " * -1);\n        left: 50%;\n        transform: translateX(-50%);\n        width: ",
        ";\n        height: ",
        ";\n        background-color: ",
        ";\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: ",
        ";\n      user-select: none;\n\n      &::before {\n        left: 0;\n        transform: translateX(0);\n      }\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        &::before {\n          height: ",
        ";\n        }\n      "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.17;\n  margin: 0;\n\n  ",
        "\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n\n    ",
        "\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: calc(",
        " * -1);\n        left: 50%;\n        transform: translateX(-50%);\n        width: ",
        ";\n        height: ",
        ";\n        background-color: ",
        ";\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      margin-top: ",
        ";\n      user-select: none;\n\n      &::before {\n        left: 0;\n        transform: translateX(0);\n      }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.12;\n  margin: 0;\n\n  ",
        "\n\n  ",
        "\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-family: ",
        ";\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.14;\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var Heading1 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h1.withConfig */ .ZP.h1.withConfig({
    componentId: "sc-f61a956f-0"
})(_templateObject3(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl3"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl3"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("cyan_700"));
}, function(param) {
    var alignLeft = param.alignLeft;
    return alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject1(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl4"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject2(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl5"));
var Heading2 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    componentId: "sc-f61a956f-1"
})(_templateObject7(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl2"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject4(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl3"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("indigo_500"));
}, function(param) {
    var alignLeft = param.alignLeft;
    return alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject5(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl3"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject6(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl4"));
var Heading3 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    componentId: "sc-f61a956f-2"
})(_templateObject10(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("black"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl"), function(param) {
    var editorial = param.editorial;
    return editorial && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject8(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl3"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xs2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .color */ .$_)("mint_900"));
}, function(param) {
    var alignLeft = param.alignLeft;
    return alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject9(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .spacing */ .W0)("xl4"));
}, (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl2"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl3"));
var Heading4 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h4.withConfig */ .ZP.h4.withConfig({
    componentId: "sc-f61a956f-3"
})(_templateObject11(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl2"));
var Heading5 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h5.withConfig */ .ZP.h5.withConfig({
    componentId: "sc-f61a956f-4"
})(_templateObject12(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("xl"));
var Heading6 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h6.withConfig */ .ZP.h6.withConfig({
    componentId: "sc-f61a956f-5"
})(_templateObject13(), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontFamily */ .I8)("serif"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontWeight */ .Ue)("bold"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("sm"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("md"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .screen */ .sp)("lg"), (0,_theme__WEBPACK_IMPORTED_MODULE_1__/* .fontSize */ .JB)("lg"));


/***/ }),

/***/ 84110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* reexport safe */ _useFeatureFlag__WEBPACK_IMPORTED_MODULE_0__.y; }
/* harmony export */ });
/* harmony import */ var _useFeatureFlag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92552);



/***/ }),

/***/ 92552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useFeatureFlag; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22970);
/* harmony import */ var context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23357);
/* harmony import */ var flagsmith_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98861);
/* harmony import */ var flagsmith_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(flagsmith_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);





// Hook.
// -----------------------------------------------------------------------------
var useFeatureFlag = function(feature) {
    // Hooks.
    // ---------------------------------------------------------------------------
    var flags = (0,flagsmith_react__WEBPACK_IMPORTED_MODULE_1__.useFlags)([
        feature
    ]);
    var flagsmith = (0,flagsmith_react__WEBPACK_IMPORTED_MODULE_1__.useFlagsmith)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(!flagsmith.identity), isLoading = ref[0], setIsLoading = ref[1];
    // TODO: We should work with a Manfredite domain object her at some point
    var user = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(context_logged_user_loggeduser_context__WEBPACK_IMPORTED_MODULE_0__/* .LoggedUserContext */ .Vi).user;
    // Functions.
    // ---------------------------------------------------------------------------
    var identify = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var email;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(flagsmith.initialised && !flagsmith.identity && user && user.email)) return [
                        3,
                        2
                    ];
                    email = user.email;
                    return [
                        4,
                        flagsmith.identify(email, {
                            email: email,
                            manfrediteId: user.id || null
                        })
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        flagsmith,
        user
    ]);
    // Effects.
    // ---------------------------------------------------------------------------
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        identify();
    }, [
        identify
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (flagsmith.initialised) {
            setIsLoading(false);
        }
    }, [
        flagsmith.identity,
        flagsmith.initialised
    ]);
    // Return
    // ---------------------------------------------------------------------------
    return {
        isEnabled: flags[feature].enabled,
        isLoading: isLoading,
        getAllTraits: flagsmith.getAllTraits,
        getTrait: flagsmith.getTrait,
        setTrait: flagsmith.setTrait
    };
};


/***/ }),

/***/ 56002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* reexport */ usePageTrack; }
});

// EXTERNAL MODULE: ./context/logged-user/loggeduser.context.tsx
var loggeduser_context = __webpack_require__(23357);
// EXTERNAL MODULE: ./hooks/useFeatureFlag/index.ts
var useFeatureFlag = __webpack_require__(84110);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
;// CONCATENATED MODULE: ./hooks/usePageTrack/usePageTrack.ts




var usePageTrack = function(event) {
    var ref = (0,react.useContext)(loggeduser_context/* LoggedUserContext */.Vi), user = ref.user, loadingUser = ref.loadingUser;
    var ref1 = (0,useFeatureFlag/* useFeatureFlag */.y)("talent_manfredite_profile_page_tracking"), isEnabled = ref1.isEnabled, isLoadingFeatureFlag = ref1.isLoading;
    var alreadySent = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        // Still loading feature flag values
        if (isLoadingFeatureFlag) {
            return;
        }
        // If event is "Public Profile - Page Loaded" and feature flag is disabled, do not track
        var isPublicProfileTrackDisabled = !isLoadingFeatureFlag && !isEnabled && event === "Public Profile - Page Loaded";
        if (isPublicProfileTrackDisabled) {
            return;
        }
        // When user info (if any) is already loaded and event is not tracked yet => Track it
        if (!alreadySent.current) {
            var urlParams = new URLSearchParams(window.location.search);
            // Identify user with campaign traits if user is logged in and campaign exists
            if (urlParams.get("utm_campaign")) {
                identifyUserWithCampaign(urlParams);
            }
            service_event_tracking/* default.page */.Z.page(event, {
                userId: (user === null || user === void 0 ? void 0 : user.id) ? "userId-".concat(user.id) : undefined
            });
            alreadySent.current = true;
        }
    }, [
        loadingUser,
        event,
        user === null || user === void 0 ? void 0 : user.id,
        isLoadingFeatureFlag,
        isEnabled
    ]);
};
function identifyUserWithCampaign(urlParams) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    service_event_tracking/* default.identifyAnonymous */.Z.identifyAnonymous({
        "campaign.name": ((ref = urlParams.get("utm_campaign")) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || undefined,
        "campaign.source": ((ref1 = urlParams.get("utm_source")) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || undefined,
        "campaign.medium": ((ref2 = urlParams.get("utm_medium")) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) || undefined,
        "campaign.term": ((ref3 = urlParams.get("utm_term")) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) || undefined,
        "campaign.content": ((ref4 = urlParams.get("utm_content")) === null || ref4 === void 0 ? void 0 : ref4.toLowerCase()) || undefined,
        "campaign.id": ((ref5 = urlParams.get("utm_id")) === null || ref5 === void 0 ? void 0 : ref5.toLowerCase()) || undefined
    });
}

;// CONCATENATED MODULE: ./hooks/usePageTrack/index.ts



/***/ }),

/***/ 64378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ state_of_hiring; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 13 modules
var Page = __webpack_require__(9092);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(70423);
// EXTERNAL MODULE: ./components/shared/HtmlTrans.tsx
var HtmlTrans = __webpack_require__(97210);
// EXTERNAL MODULE: ./components/shared/Typography.js
var Typography = __webpack_require__(99655);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/component/ResponsiveContainer.js + 1 modules
var ResponsiveContainer = __webpack_require__(61660);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/chart/generateCategoricalChart.js + 7 modules
var generateCategoricalChart = __webpack_require__(39592);
// EXTERNAL MODULE: ../../node_modules/lodash/isEqual.js
var isEqual = __webpack_require__(18149);
var isEqual_default = /*#__PURE__*/__webpack_require__.n(isEqual);
// EXTERNAL MODULE: ../../node_modules/lodash/isNaN.js
var lodash_isNaN = __webpack_require__(16951);
var isNaN_default = /*#__PURE__*/__webpack_require__.n(lodash_isNaN);
// EXTERNAL MODULE: ../../node_modules/lodash/max.js
var max = __webpack_require__(71644);
var max_default = /*#__PURE__*/__webpack_require__.n(max);
// EXTERNAL MODULE: ../../node_modules/lodash/isFunction.js
var isFunction = __webpack_require__(61049);
var isFunction_default = /*#__PURE__*/__webpack_require__.n(isFunction);
// EXTERNAL MODULE: ../../node_modules/lodash/get.js
var get = __webpack_require__(72579);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ../../node_modules/lodash/isNil.js
var isNil = __webpack_require__(1842);
var isNil_default = /*#__PURE__*/__webpack_require__.n(isNil);
// EXTERNAL MODULE: ../../node_modules/lodash/isArray.js
var isArray = __webpack_require__(86152);
var isArray_default = /*#__PURE__*/__webpack_require__.n(isArray);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(12524);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/react-smooth/es6/index.js + 8 modules
var es6 = __webpack_require__(33057);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/shape/Curve.js + 12 modules
var Curve = __webpack_require__(67704);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/shape/Dot.js
var Dot = __webpack_require__(47055);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/container/Layer.js
var Layer = __webpack_require__(84618);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/component/LabelList.js
var LabelList = __webpack_require__(96621);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/util/Global.js
var Global = __webpack_require__(79499);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/util/DataUtils.js
var DataUtils = __webpack_require__(15027);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/util/ChartUtils.js + 89 modules
var ChartUtils = __webpack_require__(39442);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/util/types.js
var types = __webpack_require__(21442);
;// CONCATENATED MODULE: ../../node_modules/recharts/es6/cartesian/Area.js
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }









function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @fileOverview Area
 */











var Area = /*#__PURE__*/function (_PureComponent) {
  _inherits(Area, _PureComponent);

  var _super = _createSuper(Area);

  function Area() {
    var _this;

    _classCallCheck(this, Area);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      isAnimationFinished: true
    };
    _this.id = (0,DataUtils/* uniqueId */.EL)('recharts-area-');

    _this.handleAnimationEnd = function () {
      var onAnimationEnd = _this.props.onAnimationEnd;

      _this.setState({
        isAnimationFinished: true
      });

      if (isFunction_default()(onAnimationEnd)) {
        onAnimationEnd();
      }
    };

    _this.handleAnimationStart = function () {
      var onAnimationStart = _this.props.onAnimationStart;

      _this.setState({
        isAnimationFinished: false
      });

      if (isFunction_default()(onAnimationStart)) {
        onAnimationStart();
      }
    };

    return _this;
  }

  _createClass(Area, [{
    key: "renderDots",
    value: function renderDots(needClip, clipPathId) {
      var isAnimationActive = this.props.isAnimationActive;
      var isAnimationFinished = this.state.isAnimationFinished;

      if (isAnimationActive && !isAnimationFinished) {
        return null;
      }

      var _this$props = this.props,
          dot = _this$props.dot,
          points = _this$props.points,
          dataKey = _this$props.dataKey;
      var areaProps = (0,types/* filterProps */.L6)(this.props);
      var customDotProps = (0,types/* filterProps */.L6)(dot, true);
      var dots = points.map(function (entry, i) {
        var dotProps = _objectSpread(_objectSpread(_objectSpread({
          key: "dot-".concat(i),
          r: 3
        }, areaProps), customDotProps), {}, {
          dataKey: dataKey,
          cx: entry.x,
          cy: entry.y,
          index: i,
          value: entry.value,
          payload: entry.payload
        });

        return Area.renderDotItem(dot, dotProps);
      });
      var dotsProps = {
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
      };
      return /*#__PURE__*/react.createElement(Layer/* Layer */.m, _extends({
        className: "recharts-area-dots"
      }, dotsProps), dots);
    }
  }, {
    key: "renderHorizontalRect",
    value: function renderHorizontalRect(alpha) {
      var _this$props2 = this.props,
          baseLine = _this$props2.baseLine,
          points = _this$props2.points,
          strokeWidth = _this$props2.strokeWidth;
      var startX = points[0].x;
      var endX = points[points.length - 1].x;
      var width = alpha * Math.abs(startX - endX);

      var maxY = max_default()(points.map(function (entry) {
        return entry.y || 0;
      }));

      if ((0,DataUtils/* isNumber */.hj)(baseLine) && typeof baseLine === 'number') {
        maxY = Math.max(baseLine, maxY);
      } else if (baseLine && isArray_default()(baseLine) && baseLine.length) {
        maxY = Math.max(max_default()(baseLine.map(function (entry) {
          return entry.y || 0;
        })), maxY);
      }

      if ((0,DataUtils/* isNumber */.hj)(maxY)) {
        return /*#__PURE__*/react.createElement("rect", {
          x: startX < endX ? startX : startX - width,
          y: 0,
          width: width,
          height: Math.floor(maxY + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1))
        });
      }

      return null;
    }
  }, {
    key: "renderVerticalRect",
    value: function renderVerticalRect(alpha) {
      var _this$props3 = this.props,
          baseLine = _this$props3.baseLine,
          points = _this$props3.points,
          strokeWidth = _this$props3.strokeWidth;
      var startY = points[0].y;
      var endY = points[points.length - 1].y;
      var height = alpha * Math.abs(startY - endY);

      var maxX = max_default()(points.map(function (entry) {
        return entry.x || 0;
      }));

      if ((0,DataUtils/* isNumber */.hj)(baseLine) && typeof baseLine === 'number') {
        maxX = Math.max(baseLine, maxX);
      } else if (baseLine && isArray_default()(baseLine) && baseLine.length) {
        maxX = Math.max(max_default()(baseLine.map(function (entry) {
          return entry.x || 0;
        })), maxX);
      }

      if ((0,DataUtils/* isNumber */.hj)(maxX)) {
        return /*#__PURE__*/react.createElement("rect", {
          x: 0,
          y: startY < endY ? startY : startY - height,
          width: maxX + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1),
          height: Math.floor(height)
        });
      }

      return null;
    }
  }, {
    key: "renderClipRect",
    value: function renderClipRect(alpha) {
      var layout = this.props.layout;

      if (layout === 'vertical') {
        return this.renderVerticalRect(alpha);
      }

      return this.renderHorizontalRect(alpha);
    }
  }, {
    key: "renderAreaStatically",
    value: function renderAreaStatically(points, baseLine, needClip, clipPathId) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      var _this$props4 = this.props,
          layout = _this$props4.layout,
          type = _this$props4.type,
          stroke = _this$props4.stroke,
          connectNulls = _this$props4.connectNulls,
          isRange = _this$props4.isRange,
          ref = _this$props4.ref,
          others = _objectWithoutProperties(_this$props4, ["layout", "type", "stroke", "connectNulls", "isRange", "ref"]);

      return /*#__PURE__*/react.createElement(Layer/* Layer */.m, {
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
      }, /*#__PURE__*/react.createElement(Curve/* Curve */.H, _extends({}, (0,types/* filterProps */.L6)(others, true), {
        points: points,
        connectNulls: connectNulls,
        type: type,
        baseLine: baseLine,
        layout: layout,
        stroke: "none",
        className: "recharts-area-area"
      })), stroke !== 'none' && /*#__PURE__*/react.createElement(Curve/* Curve */.H, _extends({}, (0,types/* filterProps */.L6)(this.props), {
        className: "recharts-area-curve",
        layout: layout,
        type: type,
        connectNulls: connectNulls,
        fill: "none",
        points: points
      })), stroke !== 'none' && isRange && /*#__PURE__*/react.createElement(Curve/* Curve */.H, _extends({}, (0,types/* filterProps */.L6)(this.props), {
        className: "recharts-area-curve",
        layout: layout,
        type: type,
        connectNulls: connectNulls,
        fill: "none",
        points: baseLine
      })));
    }
  }, {
    key: "renderAreaWithAnimation",
    value: function renderAreaWithAnimation(needClip, clipPathId) {
      var _this2 = this;

      var _this$props5 = this.props,
          points = _this$props5.points,
          baseLine = _this$props5.baseLine,
          isAnimationActive = _this$props5.isAnimationActive,
          animationBegin = _this$props5.animationBegin,
          animationDuration = _this$props5.animationDuration,
          animationEasing = _this$props5.animationEasing,
          animationId = _this$props5.animationId;
      var _this$state = this.state,
          prevPoints = _this$state.prevPoints,
          prevBaseLine = _this$state.prevBaseLine; // const clipPathId = _.isNil(id) ? this.id : id;

      return /*#__PURE__*/react.createElement(es6/* default */.ZP, {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "area-".concat(animationId),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function (_ref) {
        var t = _ref.t;

        if (prevPoints) {
          var prevPointsDiffFactor = prevPoints.length / points.length; // update animtaion

          var stepPoints = points.map(function (entry, index) {
            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);

            if (prevPoints[prevPointIndex]) {
              var prev = prevPoints[prevPointIndex];
              var interpolatorX = (0,DataUtils/* interpolateNumber */.k4)(prev.x, entry.x);
              var interpolatorY = (0,DataUtils/* interpolateNumber */.k4)(prev.y, entry.y);
              return _objectSpread(_objectSpread({}, entry), {}, {
                x: interpolatorX(t),
                y: interpolatorY(t)
              });
            }

            return entry;
          });
          var stepBaseLine;

          if ((0,DataUtils/* isNumber */.hj)(baseLine) && typeof baseLine === 'number') {
            var interpolator = (0,DataUtils/* interpolateNumber */.k4)(prevBaseLine, baseLine);
            stepBaseLine = interpolator(t);
          } else if (isNil_default()(baseLine) || isNaN_default()(baseLine)) {
            var _interpolator = (0,DataUtils/* interpolateNumber */.k4)(prevBaseLine, 0);

            stepBaseLine = _interpolator(t);
          } else {
            stepBaseLine = baseLine.map(function (entry, index) {
              var prevPointIndex = Math.floor(index * prevPointsDiffFactor);

              if (prevBaseLine[prevPointIndex]) {
                var prev = prevBaseLine[prevPointIndex];
                var interpolatorX = (0,DataUtils/* interpolateNumber */.k4)(prev.x, entry.x);
                var interpolatorY = (0,DataUtils/* interpolateNumber */.k4)(prev.y, entry.y);
                return _objectSpread(_objectSpread({}, entry), {}, {
                  x: interpolatorX(t),
                  y: interpolatorY(t)
                });
              }

              return entry;
            });
          }

          return _this2.renderAreaStatically(stepPoints, stepBaseLine, needClip, clipPathId);
        }

        return /*#__PURE__*/react.createElement(Layer/* Layer */.m, null, /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
          id: "animationClipPath-".concat(clipPathId)
        }, _this2.renderClipRect(t))), /*#__PURE__*/react.createElement(Layer/* Layer */.m, {
          clipPath: "url(#animationClipPath-".concat(clipPathId, ")")
        }, _this2.renderAreaStatically(points, baseLine, needClip, clipPathId)));
      });
    }
  }, {
    key: "renderArea",
    value: function renderArea(needClip, clipPathId) {
      var _this$props6 = this.props,
          points = _this$props6.points,
          baseLine = _this$props6.baseLine,
          isAnimationActive = _this$props6.isAnimationActive;
      var _this$state2 = this.state,
          prevPoints = _this$state2.prevPoints,
          prevBaseLine = _this$state2.prevBaseLine,
          totalLength = _this$state2.totalLength;

      if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !isEqual_default()(prevPoints, points) || !isEqual_default()(prevBaseLine, baseLine))) {
        return this.renderAreaWithAnimation(needClip, clipPathId);
      }

      return this.renderAreaStatically(points, baseLine, needClip, clipPathId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          hide = _this$props7.hide,
          dot = _this$props7.dot,
          points = _this$props7.points,
          className = _this$props7.className,
          top = _this$props7.top,
          left = _this$props7.left,
          xAxis = _this$props7.xAxis,
          yAxis = _this$props7.yAxis,
          width = _this$props7.width,
          height = _this$props7.height,
          isAnimationActive = _this$props7.isAnimationActive,
          id = _this$props7.id;

      if (hide || !points || !points.length) {
        return null;
      }

      var isAnimationFinished = this.state.isAnimationFinished;
      var hasSinglePoint = points.length === 1;
      var layerClass = classnames_default()('recharts-area', className);
      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
      var clipPathId = isNil_default()(id) ? this.id : id;
      return /*#__PURE__*/react.createElement(Layer/* Layer */.m, {
        className: layerClass
      }, needClip ? /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
        id: "clipPath-".concat(clipPathId)
      }, /*#__PURE__*/react.createElement("rect", {
        x: left,
        y: top,
        width: width,
        height: Math.floor(height)
      }))) : null, !hasSinglePoint ? this.renderArea(needClip, clipPathId) : null, (dot || hasSinglePoint) && this.renderDots(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && LabelList/* LabelList.renderCallByParent */.e.renderCallByParent(this.props, points));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.animationId !== prevState.prevAnimationId) {
        return {
          prevAnimationId: nextProps.animationId,
          curPoints: nextProps.points,
          curBaseLine: nextProps.baseLine,
          prevPoints: prevState.curPoints,
          prevBaseLine: prevState.curBaseLine
        };
      }

      if (nextProps.points !== prevState.curPoints || nextProps.baseLine !== prevState.curBaseLine) {
        return {
          curPoints: nextProps.points,
          curBaseLine: nextProps.baseLine
        };
      }

      return null;
    }
  }]);

  return Area;
}(react.PureComponent);
Area.displayName = 'Area';
Area.defaultProps = {
  stroke: '#3182bd',
  fill: '#3182bd',
  fillOpacity: 0.6,
  xAxisId: 0,
  yAxisId: 0,
  legendType: 'line',
  connectNulls: false,
  // points of area
  points: [],
  dot: false,
  activeDot: true,
  hide: false,
  isAnimationActive: !Global/* Global.isSsr */.x.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease'
};

Area.getBaseValue = function (props, xAxis, yAxis) {
  var layout = props.layout,
      baseValue = props.baseValue;

  if ((0,DataUtils/* isNumber */.hj)(baseValue) && typeof baseValue === 'number') {
    return baseValue;
  }

  var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
  var domain = numericAxis.scale.domain();

  if (numericAxis.type === 'number') {
    var max = Math.max(domain[0], domain[1]);
    var min = Math.min(domain[0], domain[1]);

    if (baseValue === 'dataMin') {
      return min;
    }

    if (baseValue === 'dataMax') {
      return max;
    }

    return max < 0 ? max : Math.max(Math.min(domain[0], domain[1]), 0);
  }

  if (baseValue === 'dataMin') {
    return domain[0];
  }

  if (baseValue === 'dataMax') {
    return domain[1];
  }

  return domain[0];
};

Area.getComposedData = function (_ref2) {
  var props = _ref2.props,
      xAxis = _ref2.xAxis,
      yAxis = _ref2.yAxis,
      xAxisTicks = _ref2.xAxisTicks,
      yAxisTicks = _ref2.yAxisTicks,
      bandSize = _ref2.bandSize,
      dataKey = _ref2.dataKey,
      stackedData = _ref2.stackedData,
      dataStartIndex = _ref2.dataStartIndex,
      displayedData = _ref2.displayedData,
      offset = _ref2.offset;
  var layout = props.layout;
  var hasStack = stackedData && stackedData.length;
  var baseValue = Area.getBaseValue(props, xAxis, yAxis);
  var isRange = false;
  var points = displayedData.map(function (entry, index) {
    var originalValue = (0,ChartUtils/* getValueByDataKey */.F$)(entry, dataKey);
    var value;

    if (hasStack) {
      value = stackedData[dataStartIndex + index];
    } else {
      value = originalValue;

      if (!isArray_default()(value)) {
        value = [baseValue, value];
      } else {
        isRange = true;
      }
    }

    var isBreakPoint = isNil_default()(value[1]) || hasStack && isNil_default()(originalValue);

    if (layout === 'horizontal') {
      return {
        x: (0,ChartUtils/* getCateCoordinateOfLine */.Hv)({
          axis: xAxis,
          ticks: xAxisTicks,
          bandSize: bandSize,
          entry: entry,
          index: index
        }),
        y: isBreakPoint ? null : yAxis.scale(value[1]),
        value: value,
        payload: entry
      };
    }

    return {
      x: isBreakPoint ? null : xAxis.scale(value[1]),
      y: (0,ChartUtils/* getCateCoordinateOfLine */.Hv)({
        axis: yAxis,
        ticks: yAxisTicks,
        bandSize: bandSize,
        entry: entry,
        index: index
      }),
      value: value,
      payload: entry
    };
  });
  var baseLine;

  if (hasStack || isRange) {
    baseLine = points.map(function (entry) {
      if (layout === 'horizontal') {
        return {
          x: entry.x,
          y: !isNil_default()(get_default()(entry, 'value[0]')) && !isNil_default()(get_default()(entry, 'y')) ? yAxis.scale(get_default()(entry, 'value[0]')) : null
        };
      }

      return {
        x: !isNil_default()(get_default()(entry, 'value[0]')) ? xAxis.scale(get_default()(entry, 'value[0]')) : null,
        y: entry.y
      };
    });
  } else if (layout === 'horizontal') {
    baseLine = yAxis.scale(baseValue);
  } else {
    baseLine = xAxis.scale(baseValue);
  }

  return _objectSpread({
    points: points,
    baseLine: baseLine,
    layout: layout,
    isRange: isRange
  }, offset);
};

Area.renderDotItem = function (option, props) {
  var dotItem;

  if ( /*#__PURE__*/react.isValidElement(option)) {
    dotItem = /*#__PURE__*/react.cloneElement(option, props);
  } else if (isFunction_default()(option)) {
    dotItem = option(props);
  } else {
    dotItem = /*#__PURE__*/react.createElement(Dot/* Dot */.o, _extends({}, props, {
      className: "recharts-area-dot"
    }));
  }

  return dotItem;
};
// EXTERNAL MODULE: ../../node_modules/recharts/es6/cartesian/Bar.js
var Bar = __webpack_require__(24908);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/cartesian/Line.js
var Line = __webpack_require__(63004);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/util/ReactUtils.js
var ReactUtils = __webpack_require__(79376);
;// CONCATENATED MODULE: ../../node_modules/recharts/es6/cartesian/ZAxis.js
/**
 * @fileOverview Z Axis
 */
var ZAxis = function ZAxis() {
  return null;
};
ZAxis.displayName = 'ZAxis';
ZAxis.defaultProps = {
  zAxisId: 0,
  range: [64, 64],
  scale: 'auto',
  type: 'number'
};
// EXTERNAL MODULE: ../../node_modules/recharts/es6/shape/Symbols.js + 9 modules
var Symbols = __webpack_require__(85135);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/cartesian/ErrorBar.js
var ErrorBar = __webpack_require__(24388);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/component/Cell.js
var Cell = __webpack_require__(11011);
;// CONCATENATED MODULE: ../../node_modules/recharts/es6/cartesian/Scatter.js
function Scatter_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Scatter_typeof = function _typeof(obj) { return typeof obj; }; } else { Scatter_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Scatter_typeof(obj); }





function Scatter_extends() { Scatter_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Scatter_extends.apply(this, arguments); }

function Scatter_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function Scatter_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Scatter_ownKeys(Object(source), true).forEach(function (key) { Scatter_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Scatter_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Scatter_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Scatter_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Scatter_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Scatter_createClass(Constructor, protoProps, staticProps) { if (protoProps) Scatter_defineProperties(Constructor.prototype, protoProps); if (staticProps) Scatter_defineProperties(Constructor, staticProps); return Constructor; }

function Scatter_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) Scatter_setPrototypeOf(subClass, superClass); }

function Scatter_setPrototypeOf(o, p) { Scatter_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return Scatter_setPrototypeOf(o, p); }

function Scatter_createSuper(Derived) { var hasNativeReflectConstruct = Scatter_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Scatter_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Scatter_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Scatter_possibleConstructorReturn(this, result); }; }

function Scatter_possibleConstructorReturn(self, call) { if (call && (Scatter_typeof(call) === "object" || typeof call === "function")) { return call; } return Scatter_assertThisInitialized(self); }

function Scatter_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Scatter_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function Scatter_getPrototypeOf(o) { Scatter_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return Scatter_getPrototypeOf(o); }

/**
 * @fileOverview Render a group of scatters
 */















var Scatter = /*#__PURE__*/function (_PureComponent) {
  Scatter_inherits(Scatter, _PureComponent);

  var _super = Scatter_createSuper(Scatter);

  function Scatter() {
    var _this;

    Scatter_classCallCheck(this, Scatter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      isAnimationFinished: false
    };

    _this.handleAnimationEnd = function () {
      _this.setState({
        isAnimationFinished: true
      });
    };

    _this.handleAnimationStart = function () {
      _this.setState({
        isAnimationFinished: false
      });
    };

    _this.id = (0,DataUtils/* uniqueId */.EL)('recharts-scatter-');
    return _this;
  }

  Scatter_createClass(Scatter, [{
    key: "renderSymbolsStatically",
    value: function renderSymbolsStatically(points) {
      var _this2 = this;

      var _this$props = this.props,
          shape = _this$props.shape,
          activeShape = _this$props.activeShape,
          activeIndex = _this$props.activeIndex;
      var baseProps = (0,types/* filterProps */.L6)(this.props);
      return points.map(function (entry, i) {
        var props = Scatter_objectSpread(Scatter_objectSpread({
          key: "symbol-".concat(i)
        }, baseProps), entry);

        return /*#__PURE__*/react.createElement(Layer/* Layer */.m, Scatter_extends({
          className: "recharts-scatter-symbol"
        }, (0,types/* adaptEventsOfChild */.bw)(_this2.props, entry, i), {
          key: "symbol-".concat(i) // eslint-disable-line react/no-array-index-key

        }), Scatter.renderSymbolItem(activeIndex === i ? activeShape : shape, props));
      });
    }
  }, {
    key: "renderSymbolsWithAnimation",
    value: function renderSymbolsWithAnimation() {
      var _this3 = this;

      var _this$props2 = this.props,
          points = _this$props2.points,
          isAnimationActive = _this$props2.isAnimationActive,
          animationBegin = _this$props2.animationBegin,
          animationDuration = _this$props2.animationDuration,
          animationEasing = _this$props2.animationEasing,
          animationId = _this$props2.animationId;
      var prevPoints = this.state.prevPoints;
      return /*#__PURE__*/react.createElement(es6/* default */.ZP, {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(animationId),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function (_ref) {
        var t = _ref.t;
        var stepData = points.map(function (entry, index) {
          var prev = prevPoints && prevPoints[index];

          if (prev) {
            var interpolatorCx = (0,DataUtils/* interpolateNumber */.k4)(prev.cx, entry.cx);
            var interpolatorCy = (0,DataUtils/* interpolateNumber */.k4)(prev.cy, entry.cy);
            var interpolatorSize = (0,DataUtils/* interpolateNumber */.k4)(prev.size, entry.size);
            return Scatter_objectSpread(Scatter_objectSpread({}, entry), {}, {
              cx: interpolatorCx(t),
              cy: interpolatorCy(t),
              size: interpolatorSize(t)
            });
          }

          var interpolator = (0,DataUtils/* interpolateNumber */.k4)(0, entry.size);
          return Scatter_objectSpread(Scatter_objectSpread({}, entry), {}, {
            size: interpolator(t)
          });
        });
        return /*#__PURE__*/react.createElement(Layer/* Layer */.m, null, _this3.renderSymbolsStatically(stepData));
      });
    }
  }, {
    key: "renderSymbols",
    value: function renderSymbols() {
      var _this$props3 = this.props,
          points = _this$props3.points,
          isAnimationActive = _this$props3.isAnimationActive;
      var prevPoints = this.state.prevPoints;

      if (isAnimationActive && points && points.length && (!prevPoints || !isEqual_default()(prevPoints, points))) {
        return this.renderSymbolsWithAnimation();
      }

      return this.renderSymbolsStatically(points);
    }
  }, {
    key: "renderErrorBar",
    value: function renderErrorBar() {
      var isAnimationActive = this.props.isAnimationActive;

      if (isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }

      var _this$props4 = this.props,
          points = _this$props4.points,
          xAxis = _this$props4.xAxis,
          yAxis = _this$props4.yAxis,
          children = _this$props4.children;
      var errorBarItems = (0,ReactUtils/* findAllByType */.NN)(children, ErrorBar/* ErrorBar.displayName */.W.displayName);

      if (!errorBarItems) {
        return null;
      }

      function dataPointFormatterY(dataPoint, dataKey) {
        return {
          x: dataPoint.cx,
          y: dataPoint.cy,
          value: +dataPoint.node.y,
          errorVal: (0,ChartUtils/* getValueByDataKey */.F$)(dataPoint, dataKey)
        };
      }

      function dataPointFormatterX(dataPoint, dataKey) {
        return {
          x: dataPoint.cx,
          y: dataPoint.cy,
          value: +dataPoint.node.x,
          errorVal: (0,ChartUtils/* getValueByDataKey */.F$)(dataPoint, dataKey)
        };
      }

      return errorBarItems.map(function (item, i) {
        var direction = item.props.direction;
        return /*#__PURE__*/react.cloneElement(item, {
          key: i,
          // eslint-disable-line react/no-array-index-key
          data: points,
          xAxis: xAxis,
          yAxis: yAxis,
          layout: direction === 'x' ? 'vertical' : 'horizontal',
          dataPointFormatter: direction === 'x' ? dataPointFormatterX : dataPointFormatterY
        });
      });
    }
  }, {
    key: "renderLine",
    value: function renderLine() {
      var _this$props5 = this.props,
          points = _this$props5.points,
          line = _this$props5.line,
          lineType = _this$props5.lineType,
          lineJointType = _this$props5.lineJointType;
      var scatterProps = (0,types/* filterProps */.L6)(this.props);
      var customLineProps = (0,types/* filterProps */.L6)(line);
      var linePoints, lineItem;

      if (lineType === 'joint') {
        linePoints = points.map(function (entry) {
          return {
            x: entry.cx,
            y: entry.cy
          };
        });
      } else if (lineType === 'fitting') {
        var _getLinearRegression = (0,DataUtils/* getLinearRegression */.wr)(points),
            xmin = _getLinearRegression.xmin,
            xmax = _getLinearRegression.xmax,
            a = _getLinearRegression.a,
            b = _getLinearRegression.b;

        var linearExp = function linearExp(x) {
          return a * x + b;
        };

        linePoints = [{
          x: xmin,
          y: linearExp(xmin)
        }, {
          x: xmax,
          y: linearExp(xmax)
        }];
      }

      var lineProps = Scatter_objectSpread(Scatter_objectSpread(Scatter_objectSpread({}, scatterProps), {}, {
        fill: 'none',
        stroke: scatterProps && scatterProps.fill
      }, customLineProps), {}, {
        points: linePoints
      });

      if ( /*#__PURE__*/react.isValidElement(line)) {
        lineItem = /*#__PURE__*/react.cloneElement(line, lineProps);
      } else if (isFunction_default()(line)) {
        lineItem = line(lineProps);
      } else {
        lineItem = /*#__PURE__*/react.createElement(Curve/* Curve */.H, Scatter_extends({}, lineProps, {
          type: lineJointType
        }));
      }

      return /*#__PURE__*/react.createElement(Layer/* Layer */.m, {
        className: "recharts-scatter-line",
        key: "recharts-scatter-line"
      }, lineItem);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          hide = _this$props6.hide,
          points = _this$props6.points,
          line = _this$props6.line,
          className = _this$props6.className,
          xAxis = _this$props6.xAxis,
          yAxis = _this$props6.yAxis,
          left = _this$props6.left,
          top = _this$props6.top,
          width = _this$props6.width,
          height = _this$props6.height,
          id = _this$props6.id,
          isAnimationActive = _this$props6.isAnimationActive;

      if (hide || !points || !points.length) {
        return null;
      }

      var isAnimationFinished = this.state.isAnimationFinished;
      var layerClass = classnames_default()('recharts-scatter', className);
      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
      var clipPathId = isNil_default()(id) ? this.id : id;
      return /*#__PURE__*/react.createElement(Layer/* Layer */.m, {
        className: layerClass,
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
      }, needClip ? /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
        id: "clipPath-".concat(clipPathId)
      }, /*#__PURE__*/react.createElement("rect", {
        x: left,
        y: top,
        width: width,
        height: height
      }))) : null, line && this.renderLine(), this.renderErrorBar(), /*#__PURE__*/react.createElement(Layer/* Layer */.m, {
        key: "recharts-scatter-symbols"
      }, this.renderSymbols()), (!isAnimationActive || isAnimationFinished) && LabelList/* LabelList.renderCallByParent */.e.renderCallByParent(this.props, points));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.animationId !== prevState.prevAnimationId) {
        return {
          prevAnimationId: nextProps.animationId,
          curPoints: nextProps.points,
          prevPoints: prevState.curPoints
        };
      }

      if (nextProps.points !== prevState.curPoints) {
        return {
          curPoints: nextProps.points
        };
      }

      return null;
    }
  }, {
    key: "renderSymbolItem",
    value: function renderSymbolItem(option, props) {
      var symbol;

      if ( /*#__PURE__*/react.isValidElement(option)) {
        symbol = /*#__PURE__*/react.cloneElement(option, props);
      } else if (isFunction_default()(option)) {
        symbol = option(props);
      } else if (typeof option === 'string') {
        symbol = /*#__PURE__*/react.createElement(Symbols/* Symbols */.v, Scatter_extends({}, props, {
          type: option
        }));
      }

      return symbol;
    }
  }]);

  return Scatter;
}(react.PureComponent);
Scatter.displayName = 'Scatter';
Scatter.defaultProps = {
  xAxisId: 0,
  yAxisId: 0,
  zAxisId: 0,
  legendType: 'circle',
  lineType: 'joint',
  lineJointType: 'linear',
  data: [],
  shape: 'circle',
  hide: false,
  isAnimationActive: !Global/* Global.isSsr */.x.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: 'linear'
};

Scatter.getComposedData = function (_ref2) {
  var xAxis = _ref2.xAxis,
      yAxis = _ref2.yAxis,
      zAxis = _ref2.zAxis,
      item = _ref2.item,
      displayedData = _ref2.displayedData,
      xAxisTicks = _ref2.xAxisTicks,
      yAxisTicks = _ref2.yAxisTicks,
      offset = _ref2.offset;
  var tooltipType = item.props.tooltipType;
  var cells = (0,ReactUtils/* findAllByType */.NN)(item.props.children, Cell/* Cell.displayName */.b.displayName);
  var xAxisDataKey = isNil_default()(xAxis.dataKey) ? item.props.dataKey : xAxis.dataKey;
  var yAxisDataKey = isNil_default()(yAxis.dataKey) ? item.props.dataKey : yAxis.dataKey;
  var zAxisDataKey = zAxis && zAxis.dataKey;
  var defaultRangeZ = zAxis ? zAxis.range : ZAxis.defaultProps.range;
  var defaultZ = defaultRangeZ && defaultRangeZ[0];
  var xBandSize = xAxis.scale.bandwidth ? xAxis.scale.bandwidth() : 0;
  var yBandSize = yAxis.scale.bandwidth ? yAxis.scale.bandwidth() : 0;
  var points = displayedData.map(function (entry, index) {
    var x = (0,ChartUtils/* getValueByDataKey */.F$)(entry, xAxisDataKey);
    var y = (0,ChartUtils/* getValueByDataKey */.F$)(entry, yAxisDataKey);
    var z = !isNil_default()(zAxisDataKey) && (0,ChartUtils/* getValueByDataKey */.F$)(entry, zAxisDataKey) || '-';
    var tooltipPayload = [{
      name: isNil_default()(xAxis.dataKey) ? item.props.name : xAxis.name || xAxis.dataKey,
      unit: xAxis.unit || '',
      value: x,
      payload: entry,
      dataKey: xAxisDataKey,
      type: tooltipType
    }, {
      name: isNil_default()(yAxis.dataKey) ? item.props.name : yAxis.name || yAxis.dataKey,
      unit: yAxis.unit || '',
      value: y,
      payload: entry,
      dataKey: yAxisDataKey,
      type: tooltipType
    }];

    if (z !== '-') {
      tooltipPayload.push({
        name: zAxis.name || zAxis.dataKey,
        unit: zAxis.unit || '',
        value: z,
        payload: entry,
        dataKey: zAxisDataKey,
        type: tooltipType
      });
    }

    var cx = (0,ChartUtils/* getCateCoordinateOfLine */.Hv)({
      axis: xAxis,
      ticks: xAxisTicks,
      bandSize: xBandSize,
      entry: entry,
      index: index,
      dataKey: xAxisDataKey
    });
    var cy = (0,ChartUtils/* getCateCoordinateOfLine */.Hv)({
      axis: yAxis,
      ticks: yAxisTicks,
      bandSize: yBandSize,
      entry: entry,
      index: index,
      dataKey: yAxisDataKey
    });
    var size = z !== '-' ? zAxis.scale(z) : defaultZ;
    var radius = Math.sqrt(Math.max(size, 0) / Math.PI);
    return Scatter_objectSpread(Scatter_objectSpread({}, entry), {}, {
      cx: cx,
      cy: cy,
      x: cx - radius,
      y: cy - radius,
      xAxis: xAxis,
      yAxis: yAxis,
      zAxis: zAxis,
      width: 2 * radius,
      height: 2 * radius,
      size: size,
      node: {
        x: x,
        y: y,
        z: z
      },
      tooltipPayload: tooltipPayload,
      tooltipPosition: {
        x: cx,
        y: cy
      },
      payload: entry
    }, cells && cells[index] && cells[index].props);
  });
  return Scatter_objectSpread({
    points: points
  }, offset);
};
// EXTERNAL MODULE: ../../node_modules/recharts/es6/cartesian/XAxis.js
var XAxis = __webpack_require__(25556);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/cartesian/YAxis.js
var YAxis = __webpack_require__(3131);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/util/CartesianUtils.js
var CartesianUtils = __webpack_require__(69524);
;// CONCATENATED MODULE: ../../node_modules/recharts/es6/chart/ComposedChart.js
/**
 * @fileOverview Composed Chart
 */









var ComposedChart = (0,generateCategoricalChart/* generateCategoricalChart */.z)({
  chartName: 'ComposedChart',
  GraphicalChild: [Line/* Line */.x, Area, Bar/* Bar */.$, Scatter],
  axisComponents: [{
    axisType: 'xAxis',
    AxisComp: XAxis/* XAxis */.K
  }, {
    axisType: 'yAxis',
    AxisComp: YAxis/* YAxis */.B
  }, {
    axisType: 'zAxis',
    AxisComp: ZAxis
  }],
  formatAxisMap: CartesianUtils/* formatAxisMap */.t9
});
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/charts/Recharts.styled.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-y: hidden;\n  overflow-x: hidden;\n\n  @media (max-width: ",
        ") {\n    max-width: 100%;\n    overflow-x: auto;\n    .recharts-responsive-container {\n      min-width: 500px;\n    }\n  }\n\n  .recharts-surface {\n    max-height: 100%;\n    border-radius: ",
        " !important;\n    flex: 0 0 auto;\n    align-self: flex-start;\n    margin-top: 3px;\n  }\n\n  .recharts-cartesian-axis-line {\n    stroke: ",
        ";\n  }\n\n  .recharts-text {\n    fill: ",
        ";\n    font-size: ",
        ";\n    font-weight: ",
        ";\n  }\n\n  .recharts-label {\n    text-transform: inherit;\n    fill: ",
        ";\n  }\n\n  .recharts-legend-wrapper {\n    right: -",
        " !important;\n  }\n\n  .recharts-legend-item {\n    margin-bottom: ",
        ";\n    display: flex !important;\n    align-items: center;\n  }\n\n  &.gender .recharts-legend-item {\n    display: inline-flex !important;\n  }\n\n  .recharts-legend-item-text {\n    color: ",
        " !important;\n    font-size: ",
        ";\n    text-align: left;\n  }\n\n  /* .recharts-tooltip-cursor {\n    fill: ",
        ";\n  } */\n\n  .recharts-default-tooltip {\n    background-color: ",
        " !important;\n    border: 0 !important;\n    border-radius: ",
        ";\n    padding: ",
        " !important;\n    font-size: ",
        ";\n    color: ",
        ";\n    font-weight: ",
        ";\n    position: relative;\n\n    &::before {\n      content: '';\n      width: 0;\n      height: 0;\n      position: absolute;\n    }\n  }\n\n  .recharts-tooltip-wrapper-bottom .recharts-default-tooltip.tooltip-y::before {\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    border-bottom: 6px solid ",
        ";\n    top: -5px;\n    left: 50%;\n    right: unset;\n    transform: translateX(-50%);\n  }\n\n  .recharts-tooltip-wrapper-top .recharts-default-tooltip.tooltip-y::before {\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    border-top: 6px solid ",
        ";\n    bottom: -5px;\n    left: 50%;\n    right: unset;\n    transform: translateX(-50%);\n  }\n\n  .recharts-tooltip-wrapper-left .recharts-default-tooltip.tooltip-x::before {\n    border-top: 6px solid transparent;\n    border-bottom: 6px solid transparent;\n    border-left: 6px solid ",
        ";\n    right: -5px;\n    left: unset;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  .recharts-tooltip-wrapper-right .recharts-default-tooltip.tooltip-x::before {\n    border-top: 6px solid transparent;\n    border-bottom: 6px solid transparent;\n    border-right: 6px solid ",
        ";\n    left: -5px;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  .recharts-tooltip-item {\n    padding: 0 !important;\n    color: inherit !important;\n  }\n\n  .recharts-tooltip-item-name {\n    font-weight: ",
        ";\n  }\n\n  &.radial .recharts-default-legend {\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  &.applications {\n    .recharts-label-list .recharts-label {\n      fill: ",
        ";\n      font-weight: ",
        ";\n      transform: translateY(-2px);\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledRecharts = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-194f347b-0"
})(_templateObject(), (0,theme/* screen */.sp)("mdMax"), (0,theme/* radius */.q0)("sm"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("text_default"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("text_default"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* color */.$_)("midnight_100"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* radius */.q0)("sm"), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* color */.$_)("midnight_800"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* color */.$_)("white"), (0,theme/* fontWeight */.Ue)("extraBold"));

;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/charts/ApplicationsMonthly.tsx




var ApplicationsMonthly = function() {
    var locale = (0,router.useRouter)().locale;
    var GRAPH_10_MONTHLY_APPLICATIONS = [
        {
            label: locale === "es" ? "Ene" : "Jan",
            value: 5
        },
        {
            label: "Feb",
            value: 5
        },
        {
            label: "Mar",
            value: 9
        },
        {
            label: locale === "es" ? "Abr" : "Apr",
            value: 7
        },
        {
            label: "May",
            value: 8
        },
        {
            label: "Jun",
            value: 7
        },
        {
            label: "Jul",
            value: 7
        },
        {
            label: locale === "es" ? "Ago" : "Aug",
            value: 6
        },
        {
            label: "Sep",
            value: 9
        },
        {
            label: "Oct",
            value: 13
        },
        {
            label: "Nov",
            value: 12
        },
        {
            label: locale === "es" ? "Dic" : "Dec",
            value: 12
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            className: "applications",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                width: "99%",
                height: 140,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ComposedChart, {
                    data: GRAPH_10_MONTHLY_APPLICATIONS,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "category",
                            allowDecimals: false,
                            dataKey: "label",
                            interval: 0,
                            tickLine: false
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "number",
                            hide: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "value",
                            isAnimationActive: false,
                            fill: "#28CEBC",
                            barSize: 40,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                dataKey: "value",
                                formatter: function(value) {
                                    return [
                                        value + "%"
                                    ];
                                },
                                position: "insideBottom"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                            dataKey: "value",
                            type: "monotone",
                            dot: false,
                            stroke: "#84F6D6",
                            strokeWidth: 2
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_ApplicationsMonthly = (ApplicationsMonthly);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/charts/ApplicationsWeekly.tsx




var ApplicationsWeekly = function() {
    var locale = (0,router.useRouter)().locale;
    var GRAPH_11_WEEKLY_APPLICATIONS = [
        {
            label: locale === "es" ? "Lun" : "Mon",
            value: 18
        },
        {
            label: locale === "es" ? "Mar" : "Tue",
            value: 18
        },
        {
            label: locale === "es" ? "Mie" : "Wed",
            value: 17
        },
        {
            label: locale === "es" ? "Jue" : "Thu",
            value: 17
        },
        {
            label: locale === "es" ? "Vie" : "Fri",
            value: 15
        },
        {
            label: locale === "es" ? "Sab" : "Sat",
            value: 9
        },
        {
            label: locale === "es" ? "Dom" : "Sun",
            value: 7
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            className: "applications",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                width: "99%",
                height: 140,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ComposedChart, {
                    data: GRAPH_11_WEEKLY_APPLICATIONS,
                    margin: {
                        left: 50,
                        right: 50
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "category",
                            allowDecimals: false,
                            dataKey: "label",
                            interval: 0,
                            tickLine: false
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "number",
                            hide: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "value",
                            isAnimationActive: false,
                            fill: "#28CEBC",
                            barSize: 52,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                dataKey: "value",
                                formatter: function(value) {
                                    return [
                                        value + "%"
                                    ];
                                },
                                position: "insideBottom"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* Line */.x, {
                            dataKey: "value",
                            type: "monotone",
                            dot: false,
                            stroke: "#84F6D6",
                            strokeWidth: 2
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_ApplicationsWeekly = (ApplicationsWeekly);

// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/candidates/Candidates.styled.tsx

function Candidates_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  padding: ",
        " ",
        ";\n  margin: auto;\n"
    ]);
    Candidates_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-image: ",
        ";\n  background-repeat: no-repeat;\n  background-position: top right;\n  background-size: cover;\n  color: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.6;\n  text-align: center;\n\n  @media (min-width: ",
        ") {\n    text-align: left;\n    font-size: ",
        ";\n    line-height: 1.58;\n  }\n\n  p {\n    margin-bottom: 0;\n  }\n\n  ",
        " {\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n\n    @media (min-width: ",
        ") {\n      padding-top: ",
        ";\n      padding-bottom: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 42rem;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  max-width: ",
        ";\n  margin: auto;\n  font-size: ",
        ";\n  line-height: 1.6;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  ",
        " {\n    margin-top: 0;\n  }\n\n  > div {\n    display: flex;\n    flex-direction: column;\n    gap: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: ",
        ";\n  margin: ",
        " auto 0;\n  line-height: 1.5;\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: 1fr 1fr;\n    font-size: ",
        ";\n    line-height: 1.6;\n  }\n\n  p {\n    margin-top: 0;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin-top: ",
        ";\n\n  figure {\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    gap: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(10, auto);\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: repeat(10, 1.5rem);\n  }\n\n  > div {\n    height: ",
        ";\n    width: ",
        ";\n\n    @media (min-width: ",
        ") {\n      height: ",
        ";\n      width: ",
        ";\n    }\n\n    &.available {\n      background-color: ",
        ";\n    }\n\n    &.open {\n      background-color: ",
        ";\n    }\n\n    &.unavailable {\n      background-color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  font-size: ",
        ";\n  margin-bottom: ",
        ";\n\n  > div {\n    width: ",
        ";\n    height: ",
        ";\n    border-radius: ",
        ";\n\n    &.available {\n      background-color: ",
        ";\n    }\n\n    &.open {\n      background-color: ",
        ";\n    }\n\n    &.unavailable {\n      background-color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: ",
        " ",
        ";\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  border-radius: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  font-size: ",
        ";\n  line-height: 1.25;\n  text-transform: uppercase;\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  color: ",
        ";\n  font-size: ",
        ";\n\n  &::after {\n    content: '';\n    width: ",
        ";\n    height: ",
        ";\n    background-color: ",
        ";\n    position: absolute;\n    bottom: -",
        ";\n    left: 50%;\n    transform: translateX(-50%);\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: ",
        " ",
        ";\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  font-weight: ",
        ";\n  line-height: 1.5;\n  font-size: ",
        ";\n\n  &:first-of-type {\n    margin-top: ",
        ";\n  }\n  &:nth-of-type(2) {\n    background-color: ",
        ";\n  }\n  &:nth-of-type(3) {\n    background-color: ",
        ";\n  }\n  &:nth-of-type(4) {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  color: ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}




var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-22505e5f-0"
})(Candidates_styled_templateObject(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("md"));
var StyledBillboard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-22505e5f-1"
})(_templateObject1(), function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/stateOfHiring/polygons.svg"), "'), linear-gradient(135deg, #005153 0%, #28cebc 100%)");
}, (0,theme/* color */.$_)("white"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl2"), StyledContainer, (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl6"), (0,theme/* spacing */.W0)("xl6"));
var StyledBillboardContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-22505e5f-2"
})(_templateObject2());
var StyledBillboardTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Heading1 */.nL).withConfig({
    componentId: "sc-22505e5f-3"
})(_templateObject3(), (0,theme/* fontSize */.JB)("xl5"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl6"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl7"));
var StyledHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-22505e5f-4"
})(_templateObject4(), (0,theme/* container */.nC)("md"), (0,theme/* fontSize */.JB)("lg"));
var StyledApplicationsContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-22505e5f-5"
})(_templateObject5(), (0,theme/* spacing */.W0)("xl2"), (0,theme/* screen */.sp)("md"), Typography/* Heading2 */.XJ, (0,theme/* spacing */.W0)("xl"));
var StyledConversionsContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-22505e5f-6"
})(_templateObject6(), (0,theme/* container */.nC)("lg"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"));
var StyledAvailability = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-22505e5f-7"
})(_templateObject7(), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("lg"));
var StyledAvailabilityGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-22505e5f-8"
})(_templateObject8(), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("sm"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("lg"), (0,theme/* color */.$_)("mint_900"), (0,theme/* color */.$_)("sun_700"), (0,theme/* color */.$_)("purple_700"));
var StyledLegend = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-22505e5f-9"
})(_templateObject9(), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("md"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("sm"), (0,theme/* radius */.q0)("full"), (0,theme/* color */.$_)("mint_900"), (0,theme/* color */.$_)("sun_700"), (0,theme/* color */.$_)("purple_700"));
var StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-22505e5f-10"
})(_templateObject10(), (0,theme/* color */.$_)("sand_100"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl"), (0,theme/* radius */.q0)("lg"));
var StyledCardTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-22505e5f-11"
})(_templateObject11(), (0,theme/* fontSize */.JB)("md"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* color */.$_)("text_subtle"));
var StyledValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-22505e5f-12"
})(_templateObject12(), (0,theme/* color */.$_)("navy_500"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("navy_200"), (0,theme/* spacing */.W0)("sm"));
var StyledProgress = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-22505e5f-13"
})(_templateObject13(), (0,theme/* color */.$_)("emerald_100"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* fontSize */.JB)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* color */.$_)("emerald_150"), (0,theme/* color */.$_)("emerald_200"), (0,theme/* color */.$_)("emerald_300"));
var StyledProgressValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-22505e5f-14"
})(_templateObject14(), (0,theme/* fontFamily */.I8)("display"), (0,theme/* fontSize */.JB)("xl5"), (0,theme/* fontWeight */.Ue)("semiBold"), (0,theme/* color */.$_)("emerald_700"));

;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/candidates/Applications.tsx







var Applications = function() {
    var t = (0,useI18n/* useI18n */.Q)("state-of-hiring").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledApplicationsContent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                            editorial: true,
                            alignLeft: true,
                            children: t("state-of-hiring.candidates.applications.title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                i18nKey: "state-of-hiring.candidates.applications.content",
                                ns: "state-of-hiring"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCard, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCardTitle, {
                                    children: t("state-of-hiring.candidates.applications.monthly")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_ApplicationsMonthly, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCard, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCardTitle, {
                                    children: t("state-of-hiring.candidates.applications.weekly")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_ApplicationsWeekly, {})
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var candidates_Applications = (Applications);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/candidates/Conversions.tsx






var Conversions = function() {
    var t = (0,useI18n/* useI18n */.Q)("state-of-hiring").t;
    var availabilityData = {
        available: 40,
        open: 6,
        unavailable: 4
    };
    var conversionData = [
        {
            value: 33,
            desc: t("state-of-hiring.candidates.conversions.conversion.contacted")
        },
        {
            value: "13%",
            desc: t("state-of-hiring.candidates.conversions.conversion.presented")
        },
        {
            value: "80%",
            desc: t("state-of-hiring.candidates.conversions.conversion.interviewed")
        },
        {
            value: "22%",
            desc: t("state-of-hiring.candidates.conversions.conversion.hired")
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeader, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                    editorial: true,
                    children: t("state-of-hiring.candidates.conversions.title")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledConversionsContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                i18nKey: "state-of-hiring.candidates.conversions.content",
                                ns: "state-of-hiring"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAvailability, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCardTitle, {
                                        children: t("state-of-hiring.candidates.conversions.availability.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAvailabilityGrid, {
                                                children: [
                                                    (0,_to_consumable_array/* default */.Z)(Array(availabilityData.available)).map(function(index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "available"
                                                        }, "available_".concat(index));
                                                    }),
                                                    (0,_to_consumable_array/* default */.Z)(Array(availabilityData.open)).map(function(index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "open"
                                                        }, "open_".concat(index));
                                                    }),
                                                    (0,_to_consumable_array/* default */.Z)(Array(availabilityData.unavailable)).map(function(index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "unavailable"
                                                        }, "unavailable_".concat(index));
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("figcaption", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLegend, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "available"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: t("state-of-hiring.candidates.conversions.availability.searching-actively")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLegend, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "open"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: t("state-of-hiring.candidates.conversions.availability.open-to-offers")
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledLegend, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "unavailable"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: t("state-of-hiring.candidates.conversions.availability.not-available")
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCardTitle, {
                                children: t("state-of-hiring.candidates.conversions.conversion.title")
                            }),
                            conversionData.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProgress, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProgressValue, {
                                            children: item.value
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: item.desc
                                        })
                                    ]
                                }, index);
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var candidates_Conversions = (Conversions);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/candidates/Candidates.tsx





var Candidates = function() {
    var t = (0,useI18n/* useI18n */.Q)("state-of-hiring").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBillboard, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBillboardContent, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBillboardTitle, {
                                as: "p",
                                children: t("state-of-hiring.candidates.billboard-title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: t("state-of-hiring.candidates.billboard-desc")
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(candidates_Conversions, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(candidates_Applications, {})
        ]
    });
};
/* harmony default export */ var candidates_Candidates = (Candidates);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/durationAndCosts/DurationAndCosts.styled.tsx

function DurationAndCosts_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    DurationAndCosts_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DurationAndCosts_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  padding: ",
        " ",
        ";\n  margin: auto;\n"
    ]);
    DurationAndCosts_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DurationAndCosts_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-image: ",
        ";\n  background-repeat: no-repeat;\n  background-position: top right 10%, top right;\n  background-size: auto 120%, cover;\n  color: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.6;\n  text-align: center;\n\n  @media (min-width: ",
        ") {\n    text-align: left;\n    font-size: ",
        ";\n    line-height: 1.58;\n  }\n\n  p {\n    margin-bottom: 0;\n  }\n\n  ",
        " {\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n\n    @media (min-width: ",
        ") {\n      padding-top: ",
        ";\n      padding-bottom: ",
        ";\n    }\n  }\n"
    ]);
    DurationAndCosts_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DurationAndCosts_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 42rem;\n"
    ]);
    DurationAndCosts_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function DurationAndCosts_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    DurationAndCosts_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function DurationAndCosts_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  max-width: ",
        ";\n  margin: auto;\n  line-height: 1.5;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.6;\n  }\n"
    ]);
    DurationAndCosts_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function DurationAndCosts_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: ",
        ";\n  margin-top: ",
        ";\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: 2fr 1fr;\n  }\n\n  > div {\n    display: flex;\n    flex-direction: column;\n    gap: ",
        ";\n  }\n"
    ]);
    DurationAndCosts_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function DurationAndCosts_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: ",
        ";\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    DurationAndCosts_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function DurationAndCosts_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  font-size: ",
        ";\n  line-height: 1.25;\n  text-transform: uppercase;\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    DurationAndCosts_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function DurationAndCosts_styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  gap: ",
        ";\n  justify-content: space-between;\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n  }\n\n  &.vertical {\n    flex-direction: column;\n  }\n"
    ]);
    DurationAndCosts_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function DurationAndCosts_styled_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    DurationAndCosts_styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function DurationAndCosts_styled_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  color: ",
        ";\n  font-size: ",
        ";\n\n  &::after {\n    content: '';\n    width: ",
        ";\n    height: ",
        ";\n    background-color: ",
        ";\n    position: absolute;\n    bottom: -",
        ";\n    left: 50%;\n    transform: translateX(-50%);\n  }\n"
    ]);
    DurationAndCosts_styled_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function DurationAndCosts_styled_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n  font-weight: ",
        ";\n"
    ]);
    DurationAndCosts_styled_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function DurationAndCosts_styled_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.333;\n  color: ",
        ";\n\n  strong {\n    font-weight: ",
        ";\n  }\n"
    ]);
    DurationAndCosts_styled_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function DurationAndCosts_styled_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: ",
        ";\n  margin-top: ",
        ";\n  line-height: 1.5;\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: 2fr 1fr;\n    font-size: ",
        ";\n    line-height: 1.6;\n  }\n\n  p {\n    margin-top: 0;\n  }\n\n  ",
        " {\n    color: ",
        ";\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    DurationAndCosts_styled_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  padding: ",
        ";\n  border-radius: ",
        ";\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  font-weight: ",
        ";\n  line-height: 1.5;\n  font-size: ",
        ";\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n  font-weight: ",
        ";\n  text-transform: uppercase;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}




var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5beb8f5c-0"
})(DurationAndCosts_styled_templateObject(), (0,theme/* color */.$_)("navy_100"));
var DurationAndCosts_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5beb8f5c-1"
})(DurationAndCosts_styled_templateObject1(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("md"));
var DurationAndCosts_styled_StyledBillboard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5beb8f5c-2"
})(DurationAndCosts_styled_templateObject2(), function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/stateOfHiring/ellipses.svg"), "'), linear-gradient(116.1deg, #002240 0.64%, #147092 100%)");
}, (0,theme/* color */.$_)("white"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl2"), DurationAndCosts_styled_StyledContainer, (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl6"), (0,theme/* spacing */.W0)("xl6"));
var DurationAndCosts_styled_StyledBillboardContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5beb8f5c-3"
})(DurationAndCosts_styled_templateObject3());
var DurationAndCosts_styled_StyledBillboardTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Heading1 */.nL).withConfig({
    componentId: "sc-5beb8f5c-4"
})(DurationAndCosts_styled_templateObject4(), (0,theme/* fontSize */.JB)("xl5"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl6"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl7"));
var DurationAndCosts_styled_StyledHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5beb8f5c-5"
})(DurationAndCosts_styled_templateObject5(), (0,theme/* container */.nC)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"));
var StyledContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5beb8f5c-6"
})(DurationAndCosts_styled_templateObject6(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl"));
var DurationAndCosts_styled_StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5beb8f5c-7"
})(DurationAndCosts_styled_templateObject7(), (0,theme/* color */.$_)("white"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* radius */.q0)("lg"));
var DurationAndCosts_styled_StyledCardTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-5beb8f5c-8"
})(DurationAndCosts_styled_templateObject8(), (0,theme/* fontSize */.JB)("md"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* color */.$_)("navy_500"));
var StyledData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5beb8f5c-9"
})(DurationAndCosts_styled_templateObject9(), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("md"));
var StyledDataItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5beb8f5c-10"
})(DurationAndCosts_styled_templateObject10(), (0,theme/* spacing */.W0)("lg"), (0,theme/* fontWeight */.Ue)("extraBold"));
var DurationAndCosts_styled_StyledValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5beb8f5c-11"
})(DurationAndCosts_styled_templateObject11(), (0,theme/* color */.$_)("navy_500"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("navy_200"), (0,theme/* spacing */.W0)("sm"));
var StyledValueNumber = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-5beb8f5c-12"
})(DurationAndCosts_styled_templateObject12(), (0,theme/* fontFamily */.I8)("display"), (0,theme/* fontSize */.JB)("xl6"), (0,theme/* fontWeight */.Ue)("semiBold"));
var StyledSource = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-5beb8f5c-13"
})(DurationAndCosts_styled_templateObject13(), (0,theme/* fontSize */.JB)("xs"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* fontWeight */.Ue)("extraBold"));
var StyledStagesContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5beb8f5c-14"
})(DurationAndCosts_styled_templateObject14(), (0,theme/* container */.nC)("lg"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"), DurationAndCosts_styled_StyledCardTitle, (0,theme/* color */.$_)("text_subtle"), (0,theme/* spacing */.W0)("xl"));
var StyledHighlight = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5beb8f5c-15"
})(_templateObject15(), (0,theme/* color */.$_)("navy_150"), (0,theme/* color */.$_)("navy_500"), (0,theme/* spacing */.W0)("md"), (0,theme/* radius */.q0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* fontSize */.JB)("md"));
var StyledHighlightValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5beb8f5c-16"
})(_templateObject16(), (0,theme/* fontFamily */.I8)("display"), (0,theme/* fontSize */.JB)("xl5"), (0,theme/* fontWeight */.Ue)("semiBold"));

;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/durationAndCosts/FeesByRole.styled.tsx

function FeesByRole_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-x: auto;\n"
    ]);
    FeesByRole_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function FeesByRole_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  border-collapse: collapse;\n  text-align: center;\n  max-width: max-content;\n  margin: auto;\n\n  thead th {\n    border-bottom: 1px solid ",
        ";\n    font-size: ",
        ";\n    line-height: 1.14;\n    padding-bottom: ",
        ";\n    font-weight: ",
        ";\n    white-space: nowrap;\n\n    &:empty {\n      border-bottom-color: transparent;\n    }\n  }\n\n  tbody th {\n    text-align: right;\n    font-weight: ",
        ";\n    padding-right: ",
        ";\n    white-space: nowrap;\n  }\n\n  tbody tr {\n    transition: 0.3s;\n  }\n\n  tr:first-of-type th,\n  tr:first-of-type td {\n    padding-top: ",
        ";\n  }\n\n  &:hover tbody tr {\n    opacity: 0.5;\n  }\n\n  tbody tr:hover {\n    opacity: 1;\n  }\n"
    ]);
    FeesByRole_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function FeesByRole_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        ";\n  min-width: 7.5rem;\n  height: 2.25rem;\n  border-radius: ",
        ";\n  color: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: ",
        ";\n  font-weight: ",
        ";\n\n  &.cell-color-1 {\n    background-color: ",
        ";\n    color: ",
        ";\n  }\n  &.cell-color-2 {\n    background-color: ",
        ";\n  }\n  &.cell-color-3 {\n    background-color: ",
        ";\n  }\n  &.cell-color-4 {\n    background-color: ",
        ";\n  }\n  &.cell-color-5 {\n    background-color: ",
        ";\n  }\n  &.cell-color-6 {\n    background-color: ",
        ";\n  }\n  &.cell-color-7 {\n    background-color: ",
        ";\n  }\n"
    ]);
    FeesByRole_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var FeesByRole_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e449cb18-0"
})(FeesByRole_styled_templateObject());
var StyledTable = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    componentId: "sc-e449cb18-1"
})(FeesByRole_styled_templateObject1(), (0,theme/* color */.$_)("midnight_200"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("sm"));
var FeesByRole_styled_StyledValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e449cb18-2"
})(FeesByRole_styled_templateObject2(), (0,theme/* spacing */.W0)("xs2"), (0,theme/* radius */.q0)("sm"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* color */.$_)("white"), (0,theme/* color */.$_)("navy_500"), (0,theme/* color */.$_)("gnbu_04"), (0,theme/* color */.$_)("gnbu_05"), (0,theme/* color */.$_)("gnbu_06"), (0,theme/* color */.$_)("gnbu_07"), (0,theme/* color */.$_)("gnbu_08"), (0,theme/* color */.$_)("gnbu_09"));

;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/durationAndCosts/FeesByRole.tsx




var FeesByRole = function() {
    var t = (0,useI18n/* useI18n */.Q)("state-of-hiring").t;
    var locale = (0,router.useRouter)().locale;
    var GRAPH_06_HIRING_FEES = [
        {
            role: locale === "es" ? "Desarrollo Backend" : "Backend Developer",
            tier1: 3.7,
            tier2: 6.1,
            tier3: 7.4
        },
        {
            role: locale === "es" ? "Desarrollo Frontend" : "Frontend Developer",
            tier1: 4.5,
            tier2: 5.8,
            tier3: 7.5
        },
        {
            role: locale === "es" ? "Desarrollo Full-Stack" : "Full-Stack Developer",
            tier1: 0,
            tier2: 5.9,
            tier3: 6.8
        },
        {
            role: locale === "es" ? "Desarrollo Mobile" : "Mobile Developer",
            tier1: 4.6,
            tier2: 6.7,
            tier3: 8.3
        },
        {
            role: locale === "es" ? "Infraestructura" : "Infrastructure",
            tier1: 3.8,
            tier2: 6.0,
            tier3: 7.6
        },
        {
            role: locale === "es" ? "Datos" : "Data",
            tier1: 0,
            tier2: 6.6,
            tier3: 8.7
        },
        {
            role: "Product Manager",
            tier1: 5.0,
            tier2: 5.8,
            tier3: 7.9
        },
        {
            role: "Tech Lead",
            tier1: 0,
            tier2: 0,
            tier3: 10.1
        },
        {
            role: "Engineering Manager",
            tier1: 0,
            tier2: 0,
            tier3: 10.5
        }
    ];
    var getClassColor = function(val) {
        if (val === 0) {
            return "cell-color-1";
        }
        if (val > 0 && val <= 4) {
            return "cell-color-2";
        }
        if (val > 4 && val <= 6) {
            return "cell-color-3";
        }
        if (val > 6 && val <= 7) {
            return "cell-color-4";
        }
        if (val > 7 && val <= 8) {
            return "cell-color-5";
        }
        if (val > 8 && val <= 10) {
            return "cell-color-6";
        }
        if (val > 10) {
            return "cell-color-7";
        } else {
            return "cell-color-1";
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FeesByRole_styled_StyledContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTable, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: t("state-of-hiring.fees.junior")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: t("state-of-hiring.fees.mid-level")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                children: t("state-of-hiring.fees.senior")
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                    children: GRAPH_06_HIRING_FEES.map(function(data, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: data.role
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeesByRole_styled_StyledValue, {
                                        className: getClassColor(data.tier1),
                                        children: data.tier1 > 0 ? "€" + data.tier1 + "K" : "-"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeesByRole_styled_StyledValue, {
                                        className: getClassColor(data.tier2),
                                        children: data.tier2 > 0 ? "€" + data.tier2 + "K" : "-"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeesByRole_styled_StyledValue, {
                                        className: getClassColor(data.tier3),
                                        children: data.tier3 > 0 ? "€" + data.tier3 + "K" : "-"
                                    })
                                })
                            ]
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var durationAndCosts_FeesByRole = (FeesByRole);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/durationAndCosts/Fees.tsx





var Fees = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DurationAndCosts_styled_StyledContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DurationAndCosts_styled_StyledHeader, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                            editorial: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                i18nKey: "state-of-hiring.fees.title",
                                ns: "state-of-hiring"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                i18nKey: "state-of-hiring.fees.desc",
                                ns: "state-of-hiring"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(durationAndCosts_FeesByRole, {})
            ]
        })
    });
};
/* harmony default export */ var durationAndCosts_Fees = (Fees);

// EXTERNAL MODULE: ../../node_modules/recharts/es6/chart/BarChart.js
var BarChart = __webpack_require__(80739);
;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/charts/TestsFrequency.tsx




var TestsFrequency = function() {
    var locale = (0,router.useRouter)().locale;
    var GRAPH_05_TESTS_IN_A_HIRING_PROCESS_FREQUENCY = [
        {
            label: "Screening HR",
            value: 98
        },
        {
            label: locale === "es" ? "Prueba t\xe9cnica" : "Technical Assessment",
            value: 71
        },
        {
            label: locale === "es" ? "Entrevista t\xe9cnica" : "Technical Interview",
            value: 59
        },
        {
            label: locale === "es" ? "Entrevista con Management" : "Interview with Management",
            value: 63
        },
        {
            label: locale === "es" ? "Fit Cultural" : "Cultural Fit",
            value: 47
        },
        {
            label: locale === "es" ? "Entrevista con el equipo" : "Team Interview",
            value: 37
        },
        {
            label: locale === "es" ? "Test de Personalidad" : "Personality Test",
            value: 8
        },
        {
            label: locale === "es" ? "Prueba de idiomas" : "Language Test",
            value: 6
        },
        {
            label: locale === "es" ? "Comprobaci\xf3n de referencias" : "Reference Check",
            value: 4
        },
        {
            label: "Bar Raiser",
            value: 4
        },
        {
            label: locale === "es" ? "Entrevista con cliente" : "Interview with Client",
            value: 2
        }
    ];
    var sortedData = GRAPH_05_TESTS_IN_A_HIRING_PROCESS_FREQUENCY.sort(function(a, b) {
        return b.value - a.value;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                width: "99%",
                height: 560,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: sortedData,
                    layout: "vertical",
                    margin: {
                        right: 30
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 10
                            },
                            hide: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "label",
                            tickLine: false,
                            width: 180
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "value",
                            isAnimationActive: false,
                            fill: "#8DC3D7",
                            barSize: 74,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelList/* LabelList */.e, {
                                dataKey: "value",
                                formatter: function(value) {
                                    return [
                                        value + "%"
                                    ];
                                },
                                position: "right"
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_TestsFrequency = (TestsFrequency);

// EXTERNAL MODULE: ../../node_modules/recharts/es6/component/Tooltip.js + 1 modules
var Tooltip = __webpack_require__(47857);
;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/charts/TestsHiringProcess.tsx




var TestsHiringProcess = function() {
    var locale = (0,router.useRouter)().locale;
    var GRAPH_04_TESTS_IN_A_HIRING_PROCESS = [
        {
            label: "1",
            value: 1
        },
        {
            label: "2",
            value: 5
        },
        {
            label: "3",
            value: 22
        },
        {
            label: "4",
            value: 15
        },
        {
            label: "5",
            value: 10
        },
        {
            label: "6",
            value: 4
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                width: "99%",
                height: 300,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: GRAPH_04_TESTS_IN_A_HIRING_PROCESS,
                    margin: {
                        left: 30,
                        bottom: 20
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "category",
                            allowDecimals: false,
                            dataKey: "label",
                            tickLine: false,
                            label: {
                                value: locale === "es" ? "N\xfamero de pruebas" : "Number of tests",
                                offset: 0,
                                position: "bottom"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "number",
                            tickLine: false,
                            width: 30,
                            label: {
                                value: locale === "es" ? "Frecuencia" : "Frequency",
                                angle: -90,
                                offset: -10,
                                position: "insideLeft"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "#e6fcff"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: "",
                            formatter: function(value) {
                                return [
                                    value,
                                    ""
                                ];
                            },
                            wrapperClassName: "tooltip-x"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "value",
                            fill: "#8DC3D7",
                            barSize: 74
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_TestsHiringProcess = (TestsHiringProcess);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/durationAndCosts/Stages.tsx







var Stages = function() {
    var t = (0,useI18n/* useI18n */.Q)("state-of-hiring").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DurationAndCosts_styled_StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DurationAndCosts_styled_StyledHeader, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                    editorial: true,
                    children: t("state-of-hiring.stages.title")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledStagesContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DurationAndCosts_styled_StyledCardTitle, {
                                children: t("state-of-hiring.stages.tests-number.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_TestsHiringProcess, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                i18nKey: "state-of-hiring.stages.tests-number.desc",
                                ns: "state-of-hiring"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHighlight, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHighlightValue, {
                                        children: "3,73"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: t("state-of-hiring.stages.tests-number.highlight")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledStagesContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DurationAndCosts_styled_StyledCardTitle, {
                                children: t("state-of-hiring.stages.tests-frequency.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_TestsFrequency, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                            i18nKey: "state-of-hiring.stages.tests-frequency.desc",
                            ns: "state-of-hiring"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var durationAndCosts_Stages = (Stages);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/charts/TimeToHireRole.tsx





var TimeToHireRole = function() {
    var t = (0,useI18n/* useI18n */.Q)("state-of-hiring").t;
    var locale = (0,router.useRouter)().locale;
    var GRAPH_01_TIME_TO_HIRE_BY_ROLE = [
        {
            label: locale === "es" ? "Dise\xf1o UX/UI" : "UX/UI Design",
            value: 65
        },
        {
            label: locale === "es" ? "Ventas" : "Sales",
            value: 62
        },
        {
            label: locale === "es" ? "Desarrollo Frontend" : "Frontend Development",
            value: 57
        },
        {
            label: "Data",
            value: 52
        },
        {
            label: locale === "es" ? "Otros" : "Other",
            value: 52
        },
        {
            label: locale === "es" ? "Liderazgo T\xe9cnico" : "Tech Lead",
            value: 50
        },
        {
            label: "QA & Testing",
            value: 48
        },
        {
            label: "Engineering Management",
            value: 48
        },
        {
            label: "Product Management",
            value: 46
        },
        {
            label: locale === "es" ? "Infraestructura" : "Infraestructure",
            value: 44
        },
        {
            label: locale === "es" ? "Desarrollo Backend" : "Backend Development",
            value: 43
        },
        {
            label: locale === "es" ? "Desarrollo Mobile" : "Mobile Development",
            value: 41
        },
        {
            label: locale === "es" ? "Desarrollo Full-Stack" : "Full-Stack Development",
            value: 36
        },
        {
            label: locale === "es" ? "Arquitectura de Software" : "Software Architecture",
            value: 29
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                width: "99%",
                height: 440,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: GRAPH_01_TIME_TO_HIRE_BY_ROLE,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 10
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "label",
                            tickLine: false,
                            width: 190
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "#dffffd"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: "",
                            formatter: function(value) {
                                return [
                                    value + " " + t("state-of-hiring.time-to-hire.days"),
                                    ""
                                ];
                            },
                            wrapperClassName: "tooltip-y"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "value",
                            fill: "#147092",
                            barSize: 12,
                            radius: 6
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_TimeToHireRole = (TimeToHireRole);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/charts/TimeToHireSeniority.tsx




var TimeToHireSeniority = function() {
    var t = (0,useI18n/* useI18n */.Q)("state-of-hiring").t;
    var GRAPH_03_TIME_TO_HIRE_BY_SENIORITY = [
        {
            label: "Senior",
            value: 48,
            fill: "#147092"
        },
        {
            label: "Mid-Level",
            value: 43,
            fill: "#147092"
        },
        {
            label: "Junior",
            value: 43,
            fill: "#147092"
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                width: "99%",
                height: 132,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: GRAPH_03_TIME_TO_HIRE_BY_SENIORITY,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 10
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "label",
                            tickLine: false,
                            width: 70
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "#dffffd"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: "",
                            formatter: function(value) {
                                return [
                                    value + " " + t("state-of-hiring.time-to-hire.days"),
                                    ""
                                ];
                            },
                            wrapperClassName: "tooltip-y"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "value",
                            fill: "#147092",
                            barSize: 12,
                            radius: 6
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_TimeToHireSeniority = (TimeToHireSeniority);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/charts/TimeToHireTech.tsx





var TimeToHireTech = function() {
    var t = (0,useI18n/* useI18n */.Q)("state-of-hiring").t;
    var locale = (0,router.useRouter)().locale;
    var GRAPH_02_TIME_TO_HIRE_BY_TECH = [
        {
            label: "Python",
            value: 61
        },
        {
            label: "AWS",
            value: 56
        },
        {
            label: "Angular",
            value: 56
        },
        {
            label: "React",
            value: 52
        },
        {
            label: "JavaScript",
            value: 49
        },
        {
            label: "Vue.js",
            value: 48
        },
        {
            label: locale === "es" ? "Otros" : "Other",
            value: 48
        },
        {
            label: "Ruby",
            value: 46
        },
        {
            label: "PHP",
            value: 44
        },
        {
            label: "JAVA",
            value: 40
        },
        {
            label: ".NET",
            value: 40
        },
        {
            label: "Node.js",
            value: 37
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                width: "99%",
                height: 384,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: GRAPH_02_TIME_TO_HIRE_BY_TECH,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 10
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "label",
                            tickLine: false,
                            width: 100
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "#dffffd"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: "",
                            formatter: function(value) {
                                return [
                                    value + " " + t("state-of-hiring.time-to-hire.days"),
                                    ""
                                ];
                            },
                            wrapperClassName: "tooltip-y"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "value",
                            fill: "#147092",
                            barSize: 12,
                            radius: 6
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_TimeToHireTech = (TimeToHireTech);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/durationAndCosts/TimeToHire.tsx








var TimeToHire = function() {
    var t = (0,useI18n/* useI18n */.Q)("state-of-hiring").t;
    var techSectorData = [
        {
            value: 49,
            desc: "state-of-hiring.time-to-hire.tech-sector.time-to-hire-tech"
        },
        {
            value: 46,
            desc: "state-of-hiring.time-to-hire.tech-sector.time-to-hire-manfred"
        },
        {
            value: 42,
            desc: "state-of-hiring.time-to-hire.tech-sector.time-to-hire-recurrent"
        }
    ];
    var successData = [
        {
            value: 59,
            desc: "state-of-hiring.time-to-hire.success.unsuccessful"
        },
        {
            value: 46,
            desc: "state-of-hiring.time-to-hire.success.successful"
        }
    ];
    var locationData = [
        {
            value: 60,
            desc: "state-of-hiring.time-to-hire.location.on-site"
        },
        {
            value: 47,
            desc: "state-of-hiring.time-to-hire.location.remote"
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DurationAndCosts_styled_StyledContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DurationAndCosts_styled_StyledHeader, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                            editorial: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                i18nKey: "state-of-hiring.time-to-hire.title",
                                ns: "state-of-hiring"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                i18nKey: "state-of-hiring.time-to-hire.desc",
                                ns: "state-of-hiring"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContent, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DurationAndCosts_styled_StyledCard, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DurationAndCosts_styled_StyledCardTitle, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                ns: "state-of-hiring",
                                                i18nKey: "state-of-hiring.time-to-hire.tech-sector.title"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledData, {
                                            children: techSectorData.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDataItem, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DurationAndCosts_styled_StyledValue, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledValueNumber, {
                                                                    children: item.value
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    children: [
                                                                        " ",
                                                                        t("state-of-hiring.time-to-hire.days")
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                                ns: "state-of-hiring",
                                                                i18nKey: item.desc
                                                            })
                                                        })
                                                    ]
                                                }, index);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSource, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                                                    children: [
                                                        "*",
                                                        t("state-of-hiring.time-to-hire.tech-sector.source"),
                                                        ":"
                                                    ]
                                                }),
                                                " ",
                                                t("state-of-hiring.time-to-hire.tech-sector.source-name")
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DurationAndCosts_styled_StyledCard, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DurationAndCosts_styled_StyledCardTitle, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                ns: "state-of-hiring",
                                                i18nKey: "state-of-hiring.time-to-hire.rol.title"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_TimeToHireRole, {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DurationAndCosts_styled_StyledCard, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DurationAndCosts_styled_StyledCardTitle, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                ns: "state-of-hiring",
                                                i18nKey: "state-of-hiring.time-to-hire.main-tech.title"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_TimeToHireTech, {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DurationAndCosts_styled_StyledCard, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DurationAndCosts_styled_StyledCardTitle, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                ns: "state-of-hiring",
                                                i18nKey: "state-of-hiring.time-to-hire.success.title"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledData, {
                                            className: "vertical",
                                            children: successData.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDataItem, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DurationAndCosts_styled_StyledValue, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledValueNumber, {
                                                                    children: item.value
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    children: [
                                                                        " ",
                                                                        t("state-of-hiring.time-to-hire.days")
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                                ns: "state-of-hiring",
                                                                i18nKey: item.desc
                                                            })
                                                        })
                                                    ]
                                                }, index);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DurationAndCosts_styled_StyledCard, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DurationAndCosts_styled_StyledCardTitle, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                ns: "state-of-hiring",
                                                i18nKey: "state-of-hiring.time-to-hire.location.title"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledData, {
                                            className: "vertical",
                                            children: locationData.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDataItem, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DurationAndCosts_styled_StyledValue, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledValueNumber, {
                                                                    children: item.value
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    children: [
                                                                        " ",
                                                                        t("state-of-hiring.time-to-hire.days")
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                                ns: "state-of-hiring",
                                                                i18nKey: item.desc
                                                            })
                                                        })
                                                    ]
                                                }, index);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DurationAndCosts_styled_StyledCard, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DurationAndCosts_styled_StyledCardTitle, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                                ns: "state-of-hiring",
                                                i18nKey: "state-of-hiring.time-to-hire.seniority.title"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_TimeToHireSeniority, {})
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var durationAndCosts_TimeToHire = (TimeToHire);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/durationAndCosts/DurationAndCosts.tsx






var DurationAndCosts = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DurationAndCosts_styled_StyledBillboard, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DurationAndCosts_styled_StyledContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DurationAndCosts_styled_StyledBillboardContent, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DurationAndCosts_styled_StyledBillboardTitle, {
                                as: "p",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                    ns: "state-of-hiring",
                                    i18nKey: "state-of-hiring.time-to-hire.billboard-title"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                    ns: "state-of-hiring",
                                    i18nKey: "state-of-hiring.time-to-hire.billboard-desc"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(durationAndCosts_TimeToHire, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(durationAndCosts_Stages, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(durationAndCosts_Fees, {})
        ]
    });
};
/* harmony default export */ var durationAndCosts_DurationAndCosts = (DurationAndCosts);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/hero/StateOfHiringHero.styled.tsx

function StateOfHiringHero_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-image: ",
        ";\n  background-size: cover;\n  background-position: bottom center;\n  padding: ",
        " ",
        " ",
        ";\n  position: relative;\n\n  @media (min-width: ",
        ") {\n    background-image: ",
        ";\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n  }\n"
    ]);
    StateOfHiringHero_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function StateOfHiringHero_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  text-align: center;\n  color: ",
        ";\n  line-height: 1.5;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.4;\n  }\n"
    ]);
    StateOfHiringHero_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function StateOfHiringHero_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-bottom: ",
        ";\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  font-size: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  span {\n    font-family: ",
        ";\n    font-size: ",
        ";\n    line-height: 1;\n    color: ",
        ";\n    text-transform: uppercase;\n    font-weight: ",
        ";\n    letter-spacing: 0.35em;\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n  }\n"
    ]);
    StateOfHiringHero_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var StyledHero = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-acc06195-0"
})(StateOfHiringHero_styled_templateObject(), function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/stateOfHiring/hero-bg-sm.svg"), "')");
}, (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl6"), (0,theme/* screen */.sp)("md"), function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/stateOfHiring/hero-bg.svg"), "')");
}, (0,theme/* spacing */.W0)("xl6"), (0,theme/* spacing */.W0)("xl7"));
var StyledHeroContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-acc06195-1"
})(StateOfHiringHero_styled_templateObject1(), (0,theme/* container */.nC)("lg"), (0,theme/* color */.$_)("text_white"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"));
var StyledHeroTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Heading1 */.nL).withConfig({
    componentId: "sc-acc06195-2"
})(StateOfHiringHero_styled_templateObject2(), (0,theme/* color */.$_)("cyan_300"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xs"), (0,theme/* fontSize */.JB)("xl5"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl6"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl7"), (0,theme/* fontFamily */.I8)("sans"), (0,theme/* fontSize */.JB)("md"), (0,theme/* color */.$_)("text_white"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"));

;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/hero/StateOfHiringHero.tsx



var StateOfHiringHero = function() {
    var t = (0,useI18n/* useI18n */.Q)("state-of-hiring").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHero, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroTitle, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t("state-of-hiring.hero.pre-title")
                        }),
                        t("state-of-hiring.hero.title")
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: t("state-of-hiring.hero.desc")
                })
            ]
        })
    });
};
/* harmony default export */ var hero_StateOfHiringHero = (StateOfHiringHero);

// EXTERNAL MODULE: ../../node_modules/@fortawesome/pro-solid-svg-icons/index.mjs
var pro_solid_svg_icons = __webpack_require__(54933);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/shared/Typography.styled.tsx
var Typography_styled = __webpack_require__(90637);
;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/intro/StateOfHiringIntro.styled.tsx

function StateOfHiringIntro_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  padding: ",
        " ",
        ";\n  margin: auto;\n  ",
        " {\n    text-align: center;\n  }\n"
    ]);
    StateOfHiringIntro_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function StateOfHiringIntro_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n    gap: ",
        ";\n  }\n"
    ]);
    StateOfHiringIntro_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function StateOfHiringIntro_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 100%;\n  flex-shrink: 0;\n  border-radius: ",
        ";\n  overflow: hidden;\n\n  @media (min-width: ",
        ") {\n    max-width: 50%;\n  }\n\n  @media (min-width: ",
        ") {\n    max-width: 30rem;\n  }\n\n  img {\n    display: block;\n    border-radius: ",
        ";\n  }\n"
    ]);
    StateOfHiringIntro_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function StateOfHiringIntro_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  margin-top: 0;\n"
    ]);
    StateOfHiringIntro_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function StateOfHiringIntro_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: ",
        ";\n  margin-top: ",
        ";\n"
    ]);
    StateOfHiringIntro_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function StateOfHiringIntro_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n  font-weight: ",
        ";\n  text-transform: uppercase;\n"
    ]);
    StateOfHiringIntro_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function StateOfHiringIntro_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 24rem;\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  padding: ",
        ";\n  line-height: 1.5;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n\n  @media (min-width: ",
        ") {\n    max-width: 17rem;\n  }\n\n  p {\n    margin: 0;\n  }\n\n  &:first-child ",
        " {\n    color: ",
        ";\n  }\n  &:nth-child(2) ",
        " {\n    color: ",
        ";\n  }\n  &:nth-child(3) ",
        " {\n    color: ",
        ";\n  }\n  &:nth-child(4) ",
        " {\n    color: ",
        ";\n  }\n  &:nth-child(5) ",
        " {\n    color: ",
        ";\n  }\n  &:nth-child(6) ",
        " {\n    color: ",
        ";\n  }\n"
    ]);
    StateOfHiringIntro_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function StateOfHiringIntro_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  line-height: 1.5;\n\n  &:not(.display-full-text) {\n    display: -webkit-box;\n    -webkit-line-clamp: 12;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    word-break: break-word;\n  }\n\n  > :first-child {\n    margin-top: 0;\n  }\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n"
    ]);
    StateOfHiringIntro_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function StateOfHiringIntro_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  padding: 0;\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  position: relative;\n  width: 100%;\n\n  button {\n    padding: 0;\n    background: transparent;\n    border: 0;\n    display: flex;\n    align-items: center;\n    gap: ",
        ";\n    cursor: pointer;\n  }\n\n  svg {\n    flex-shrink: 0;\n    width: 1.25rem !important;\n    height: 1.25rem;\n    color: ",
        ";\n  }\n\n  span {\n    flex-shrink: 0;\n    color: ",
        ";\n    font-weight: ",
        ";\n    text-transform: uppercase;\n    font-size: ",
        ";\n    line-height: 1;\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n    }\n  }\n\n  &::before {\n    content: '';\n    flex-grow: 1;\n    height: 1px;\n    background-color: ",
        ";\n  }\n\n  &::after {\n    content: '';\n    flex-grow: 1;\n    height: 1px;\n    background-color: ",
        ";\n  }\n"
    ]);
    StateOfHiringIntro_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var StateOfHiringIntro_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f106f5c5-0"
})(StateOfHiringIntro_styled_templateObject(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("md"), Typography_styled/* Heading1 */.nL);
var StyledIntro = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f106f5c5-1"
})(StateOfHiringIntro_styled_templateObject1(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("mdlg"));
var StyledIntroImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f106f5c5-2"
})(StateOfHiringIntro_styled_templateObject2(), (0,theme/* radius */.q0)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("lg"), (0,theme/* radius */.q0)("lg"));
var StyledIntroTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
    componentId: "sc-f106f5c5-3"
})(StateOfHiringIntro_styled_templateObject3(), (0,theme/* color */.$_)("text_subtle"), (0,theme/* fontWeight */.Ue)("extraBold"));
var StyledSummary = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f106f5c5-4"
})(StateOfHiringIntro_styled_templateObject4(), (0,theme/* spacing */.W0)("mdlg"), (0,theme/* spacing */.W0)("xl"));
var StyledSummaryValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f106f5c5-5"
})(StateOfHiringIntro_styled_templateObject5(), (0,theme/* fontFamily */.I8)("display"), (0,theme/* fontSize */.JB)("xl6"), (0,theme/* fontWeight */.Ue)("semiBold"));
var StyledSummaryItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f106f5c5-6"
})(StateOfHiringIntro_styled_templateObject6(), (0,theme/* color */.$_)("sand_100"), (0,theme/* radius */.q0)("md"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xs"), (0,theme/* screen */.sp)("md"), StyledSummaryValue, (0,theme/* color */.$_)("indigo_500"), StyledSummaryValue, (0,theme/* color */.$_)("sun_900"), StyledSummaryValue, (0,theme/* color */.$_)("mint_900"), StyledSummaryValue, (0,theme/* color */.$_)("cyan_700"), StyledSummaryValue, (0,theme/* color */.$_)("purple_700"), StyledSummaryValue, (0,theme/* color */.$_)("positive_500"));
var StyledText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f106f5c5-7"
})(StateOfHiringIntro_styled_templateObject7());
var StyledShowMore = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f106f5c5-8"
})(StateOfHiringIntro_styled_templateObject8(), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("text_default"), (0,theme/* color */.$_)("link"), (0,theme/* fontWeight */.Ue)("black"), (0,theme/* fontSize */.JB)("sm"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("md"), (0,theme/* color */.$_)("midnight_200"), (0,theme/* color */.$_)("midnight_200"));

;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/intro/StateOfHiringIntro.tsx









var StateOfHiringIntro = function() {
    var checkLineClamp = function checkLineClamp() {
        if (clampableText.current && clampableText.current.clientHeight < clampableText.current.scrollHeight) {
            setdisplayReadMore(true);
        } else {
            setdisplayReadMore(false);
        }
    };
    var t = (0,useI18n/* useI18n */.Q)("state-of-hiring").t;
    var ref = (0,react.useState)(false), displayReadMore = ref[0], setdisplayReadMore = ref[1];
    var clampableText = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        checkLineClamp();
    }, []);
    var ref1 = (0,react.useState)(false), showAllText = ref1[0], setShowAllText = ref1[1];
    var items = [
        {
            value: t("state-of-hiring.intro.summary.time-to-hire-value"),
            desc: t("state-of-hiring.intro.summary.time-to-hire")
        },
        {
            value: t("state-of-hiring.intro.summary.tests-value"),
            desc: t("state-of-hiring.intro.summary.tests")
        },
        {
            value: t("state-of-hiring.intro.summary.fee-value"),
            desc: t("state-of-hiring.intro.summary.fee")
        },
        {
            value: t("state-of-hiring.intro.summary.success-rate-value"),
            desc: t("state-of-hiring.intro.summary.success-rate")
        },
        {
            value: t("state-of-hiring.intro.summary.turnover-value"),
            desc: t("state-of-hiring.intro.summary.turnover")
        },
        {
            value: t("state-of-hiring.intro.summary.candidates-value"),
            desc: t("state-of-hiring.intro.summary.candidates")
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StateOfHiringIntro_styled_StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledIntro, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIntroImage, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (0,paths/* getPublicPath */.A)("/images/stateOfHiring/team.jpg"),
                            alt: ""
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIntroTitle, {
                                children: t("state-of-hiring.intro.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledText, {
                                ref: clampableText,
                                className: "".concat(showAllText ? "display-full-text" : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                    i18nKey: "state-of-hiring.intro.desc",
                                    ns: "state-of-hiring"
                                })
                            }),
                            displayReadMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledShowMore, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    onClick: function() {
                                        return setShowAllText(!showAllText);
                                    },
                                    children: [
                                        !showAllText && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: pro_solid_svg_icons/* faPlusCircle */.KtF
                                        }),
                                        showAllText && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: pro_solid_svg_icons/* faMinusCircle */.uMC
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            children: [
                                                !showAllText && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: t("state-of-hiring.intro.readMore")
                                                }),
                                                showAllText && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                    children: t("state-of-hiring.intro.readLess")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading1 */.nL, {
                as: "h2",
                editorial: true,
                children: t("state-of-hiring.intro.summary.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSummary, {
                children: items.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSummaryItem, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSummaryValue, {
                                children: item.value
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                    i18nKey: item.desc,
                                    ns: "state-of-hiring"
                                })
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var intro_StateOfHiringIntro = (StateOfHiringIntro);

// EXTERNAL MODULE: ../ui-library/dist/index.js + 203 modules
var dist = __webpack_require__(78197);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9725);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/methodology/Methodology.styled.tsx

function Methodology_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  background-image: ",
        ";\n  background-size: 120%;\n  background-position: top left -20px;\n  padding: ",
        " ",
        " ",
        ";\n  position: relative;\n\n  @media (min-width: ",
        ") {\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n  }\n"
    ]);
    Methodology_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Methodology_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  text-align: center;\n  color: ",
        ";\n  line-height: 1.5;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.4;\n  }\n"
    ]);
    Methodology_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Methodology_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n  font-weight: ",
        ";\n  text-transform: uppercase;\n\n  @media (min-width: ",
        ") {\n    min-width: 1.6em;\n    text-align: right;\n  }\n"
    ]);
    Methodology_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Methodology_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  gap: 0;\n"
    ]);
    Methodology_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Methodology_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  margin: auto;\n  color: ",
        ";\n  line-height: 1.5;\n  padding: ",
        " ",
        ";\n  text-align: left;\n\n  > div {\n    max-width: 25rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: ",
        ";\n    margin: auto;\n    text-align: center;\n\n    @media (min-width: ",
        ") {\n      flex-direction: row;\n      text-align: left;\n    }\n  }\n\n  &:first-of-type {\n    background-color: ",
        ";\n    margin-top: ",
        ";\n  }\n  &:nth-of-type(2) {\n    background-color: ",
        ";\n    margin-left: ",
        ";\n    margin-right: ",
        ";\n\n    @media (min-width: ",
        ") {\n      margin-left: ",
        ";\n      margin-right: ",
        ";\n    }\n  }\n  &:nth-of-type(3) {\n    background-color: ",
        ";\n    margin-left: ",
        ";\n    margin-right: ",
        ";\n\n    @media (min-width: ",
        ") {\n      margin-left: ",
        ";\n      margin-right: ",
        ";\n    }\n  }\n  &:nth-of-type(4) {\n    margin-left: ",
        ";\n    margin-right: ",
        ";\n    background-color: ",
        ";\n    max-width: fit-content;\n\n    @media (min-width: ",
        ") {\n      margin-left: auto;\n      margin-right: auto;\n    }\n  }\n"
    ]);
    Methodology_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Methodology_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 31rem;\n  margin: ",
        " auto 0;\n  line-height: 1.5;\n\n  > div {\n    display: flex;\n    flex-wrap: wrap;\n    gap: ",
        ";\n    justify-content: center;\n    margin-top: ",
        ";\n  }\n\n  > ",
        " {\n    gap: ",
        ";\n    margin-top: ",
        ";\n  }\n"
    ]);
    Methodology_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var Methodology_styled_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2ac7f685-0"
})(Methodology_styled_templateObject(), (0,theme/* color */.$_)("midnight_900"), function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/stateOfHiring/methodology-bg.svg"), "')");
}, (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl6"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl6"), (0,theme/* spacing */.W0)("xl7"));
var Methodology_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2ac7f685-1"
})(Methodology_styled_templateObject1(), (0,theme/* container */.nC)("md"), (0,theme/* color */.$_)("text_white"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"));
var Methodology_styled_StyledValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2ac7f685-2"
})(Methodology_styled_templateObject2(), (0,theme/* fontFamily */.I8)("display"), (0,theme/* fontSize */.JB)("xl6"), (0,theme/* fontWeight */.Ue)("semiBold"), (0,theme/* screen */.sp)("md"));
var StyledSignup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2ac7f685-3"
})(Methodology_styled_templateObject3(), (0,theme/* fontSize */.JB)("md"));
var StyledFunnel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2ac7f685-4"
})(Methodology_styled_templateObject4(), (0,theme/* container */.nC)("md"), (0,theme/* color */.$_)("text_white"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("sm"), (0,theme/* screen */.sp)("md"), (0,theme/* color */.$_)("seq_blue_08"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* color */.$_)("seq_blue_07"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* color */.$_)("seq_blue_06"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* color */.$_)("seq_blue_05"), (0,theme/* screen */.sp)("md"));
var StyledBanner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-2ac7f685-5"
})(Methodology_styled_templateObject5(), (0,theme/* spacing */.W0)("xl7"), (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xl2"), StyledSignup, (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("md"));

;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/methodology/Methodology.tsx











var Methodology = function() {
    var t = (0,useI18n/* useI18n */.Q)("state-of-hiring").t;
    var locale = (0,router.useRouter)().locale;
    var funnelData = [
        {
            value: 1094,
            desc: t("state-of-hiring.methodology.companies-contacted")
        },
        {
            value: 1030,
            desc: t("state-of-hiring.methodology.companies-worked")
        },
        {
            value: 800,
            desc: t("state-of-hiring.methodology.companies-processes")
        },
        {
            value: 370,
            desc: t("state-of-hiring.methodology.companies-hired")
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Methodology_styled_StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Methodology_styled_StyledContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                    editorial: true,
                    children: t("state-of-hiring.methodology.title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                    i18nKey: "state-of-hiring.methodology.content",
                    ns: "state-of-hiring"
                }),
                funnelData.map(function(item, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFunnel, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Methodology_styled_StyledValue, {
                                    children: item.value
                                }),
                                item.desc
                            ]
                        })
                    }, index);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBanner, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading3 */.aC, {
                            editorial: true,
                            children: t("state-of-hiring.methodology.banner-title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: t("state-of-hiring.methodology.banner-desc")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "https://getmanfred.typeform.com/to/ImCbPV97?source=state-of-hiring",
                                passHref: true,
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* ButtonLink */.ZP, {
                                    schema: "brand2",
                                    variant: "hard",
                                    href: "#",
                                    startIcon: free_solid_svg_icons/* faBriefcase */.HXv,
                                    label: t("state-of-hiring.methodology.cta-companies"),
                                    onClick: function() {
                                        return service_event_tracking/* default.trackLandingCtaClicked */.Z.trackLandingCtaClicked("footer-empresas-hiring-report");
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSignup, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                i18nKey: "state-of-hiring.methodology.cta-register",
                                ns: "state-of-hiring",
                                components: {
                                    signupLink: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?locale=").concat(locale, "&source=footer-unete-hiring-report"),
                                        onClick: function(e) {
                                            return service_event_tracking/* default.trackExternalLandingCtaClicked */.Z.trackExternalLandingCtaClicked(e, "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.join */.uu.join, locale), "?locale=").concat(locale, "&source=footer-unete-hiring-report"), "footer-unete-hiring-report");
                                        }
                                    })
                                }
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var methodology_Methodology = (Methodology);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/charts/RotationRole.tsx




var RotationRole = function() {
    var locale = (0,router.useRouter)().locale;
    var GRAPH_09_ROTATION_BY_ROLE = [
        {
            label: locale === "es" ? "Administraci\xf3n de sistemas" : "Sysadmin",
            value: 27
        },
        {
            label: locale === "es" ? "Scrum M\xe1ster o Agile Coach" : "Scrum M\xe1ster & Agile Coach",
            value: 22
        },
        {
            label: locale === "es" ? "Devops, Infraestructura y SRE" : "Devops, Infra & SRE",
            value: 20
        },
        {
            label: locale === "es" ? "An\xe1lisis de Datos y BI" : "Data Analyst & BI",
            value: 20
        },
        {
            label: locale === "es" ? "Ventas y BizDev" : "Sales & BizDev",
            value: 20
        },
        {
            label: locale === "es" ? "Desarrollo Full-Stack" : "Full-Stack Dev",
            value: 18
        },
        {
            label: "Machine Learning",
            value: 18
        },
        {
            label: locale === "es" ? "Liderazgo T\xe9cnico" : "Tech Lead",
            value: 17
        },
        {
            label: locale === "es" ? "QA y Testing" : "QA & Testing",
            value: 17
        },
        {
            label: locale === "es" ? "IT Management" : "IT Manager",
            value: 17
        },
        {
            label: locale === "es" ? "Desarrollo Backend" : "Backend Dev",
            value: 16
        },
        {
            label: locale === "es" ? "Product Ownership" : "Product Owner",
            value: 15
        },
        {
            label: locale === "es" ? "Engineering Management" : "Engineering Manager",
            value: 15
        },
        {
            label: locale === "es" ? "Desarrollo Frontend" : "Frontend Dev",
            value: 15
        },
        {
            label: "Data Engineer",
            value: 14
        },
        {
            label: locale === "es" ? "Arquitectura de Software" : "Software Architect",
            value: 13
        },
        {
            label: locale === "es" ? "Project Management" : "Project Manager",
            value: 11
        },
        {
            label: locale === "es" ? "Research Developer" : "Research Dev",
            value: 11
        },
        {
            label: locale === "es" ? "Data Science" : "Data Scientist",
            value: 8
        },
        {
            label: locale === "es" ? "Product Management" : "Product Manager",
            value: 7
        },
        {
            label: locale === "es" ? "Desarrollo Mobile" : "Mobile Dev",
            value: 1
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                width: "99%",
                height: 640,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: GRAPH_09_ROTATION_BY_ROLE,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 10
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "label",
                            tickLine: false,
                            width: 220
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "#e6dfff"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: "",
                            formatter: function(value) {
                                return [
                                    value + "%",
                                    ""
                                ];
                            },
                            wrapperClassName: "tooltip-y"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "value",
                            fill: "#7d64d6",
                            barSize: 12,
                            radius: 6
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_RotationRole = (RotationRole);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/successRate/SuccessRate.styled.tsx

function SuccessRate_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n\n  &.notice {\n    background-color: ",
        ";\n    color: ",
        ";\n\n    ",
        "::before {\n      background-color: ",
        ";\n    }\n  }\n"
    ]);
    SuccessRate_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SuccessRate_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  padding: ",
        " ",
        ";\n  margin: auto;\n"
    ]);
    SuccessRate_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SuccessRate_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-image: ",
        ";\n  background-repeat: no-repeat;\n  background-position: bottom -50% right, top right;\n  background-size: 70%, cover;\n  color: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.6;\n  text-align: center;\n\n  @media (min-width: ",
        ") {\n    text-align: left;\n    font-size: ",
        ";\n    line-height: 1.58;\n    background-position: top right -20%, top right;\n    background-size: auto 130%, cover;\n  }\n\n  p {\n    margin-bottom: 0;\n  }\n\n  ",
        " {\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n\n    @media (min-width: ",
        ") {\n      padding-top: ",
        ";\n      padding-bottom: ",
        ";\n    }\n  }\n"
    ]);
    SuccessRate_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SuccessRate_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 42rem;\n"
    ]);
    SuccessRate_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SuccessRate_styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n  }\n"
    ]);
    SuccessRate_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SuccessRate_styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  max-width: ",
        ";\n  margin: auto;\n  line-height: 1.5;\n\n  @media (min-width: ",
        ") {\n    font-size: ",
        ";\n    line-height: 1.6;\n  }\n"
    ]);
    SuccessRate_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SuccessRate_styled_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  font-size: ",
        ";\n  line-height: 1.25;\n  text-transform: uppercase;\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    SuccessRate_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SuccessRate_styled_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  gap: ",
        " ",
        ";\n  max-width: ",
        ";\n  margin-left: auto;\n  margin-right: auto;\n\n  ",
        " {\n    text-align: center;\n    width: 100%;\n    color: inherit;\n  }\n"
    ]);
    SuccessRate_styled_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function SuccessRate_styled_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  padding: ",
        ";\n  border-radius: ",
        ";\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n  font-weight: ",
        ";\n  line-height: 1.5;\n  width: 100%;\n\n  @media (min-width: ",
        ") {\n    width: 47%;\n  }\n\n  @media (min-width: ",
        ") {\n    width: 31%;\n  }\n"
    ]);
    SuccessRate_styled_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function SuccessRate_styled_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  min-width: 1.25em;\n  text-align: right;\n"
    ]);
    SuccessRate_styled_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function SuccessRate_styled_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: ",
        ";\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: 2fr 1fr;\n  }\n\n  &.reverse {\n    grid-template-columns: minmax(0, 1fr);\n\n    @media (min-width: ",
        ") {\n      grid-template-columns: 1fr 2fr;\n    }\n  }\n\n  .text-lg {\n    line-height: 1.5;\n\n    @media (min-width: ",
        ") {\n      font-size: ",
        ";\n      line-height: 1.6;\n    }\n  }\n\n  > div {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: ",
        ";\n\n    ",
        " {\n      width: 100% !important;\n    }\n\n    ",
        " {\n      gap: ",
        ";\n\n      @media (min-width: ",
        ") {\n        flex-wrap: nowrap;\n      }\n\n      ",
        " {\n        flex-direction: column;\n        text-align: center;\n        width: 50%;\n      }\n    }\n  }\n"
    ]);
    SuccessRate_styled_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function SuccessRate_styled_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background-color: ",
        ";\n  padding: ",
        " ",
        ";\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  border-radius: ",
        ";\n  color: ",
        ";\n"
    ]);
    SuccessRate_styled_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function SuccessRate_styled_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    SuccessRate_styled_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function SuccessRate_styled_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        ";\n  justify-content: center;\n  flex-direction: column;\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n  }\n\n  &.vertical {\n    flex-direction: column;\n  }\n"
    ]);
    SuccessRate_styled_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function SuccessRate_styled_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  color: ",
        ";\n  font-size: ",
        ";\n\n  &::after {\n    content: '';\n    width: ",
        ";\n    height: ",
        ";\n    background-color: ",
        ";\n    position: absolute;\n    bottom: -",
        ";\n    left: 50%;\n    transform: translateX(-50%);\n  }\n"
    ]);
    SuccessRate_styled_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function SuccessRate_styled_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1;\n  font-weight: ",
        ";\n"
    ]);
    SuccessRate_styled_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function SuccessRate_styled_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.333;\n  color: ",
        ";\n  text-align: center;\n  margin-top: ",
        ";\n  strong {\n    font-weight: ",
        ";\n  }\n"
    ]);
    SuccessRate_styled_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: ",
        ";\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: ",
        ";\n  margin: ",
        " auto;\n  line-height: 1.5;\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: 3fr 1fr;\n    font-size: ",
        ";\n    line-height: 1.6;\n  }\n\n  ",
        " {\n    text-align: left;\n    margin-top: 0;\n  }\n\n  li {\n    margin-bottom: ",
        ";\n    background-image: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 0C5.37256 0 0 5.37256 0 12C0 18.6274 5.37256 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37256 18.6274 0 12 0ZM12 22.4516C6.25819 22.4516 1.54839 17.8038 1.54839 12C1.54839 6.25824 6.19621 1.54839 12 1.54839C17.7418 1.54839 22.4516 6.19621 22.4516 12C22.4516 17.7418 17.8038 22.4516 12 22.4516ZM18.8531 9.14705L10.1202 17.8099C9.8925 18.0357 9.52485 18.0343 9.29903 17.8066L5.14365 13.6176C4.91782 13.39 4.91927 13.0223 5.14694 12.7965L5.55919 12.3876C5.78685 12.1618 6.1545 12.1632 6.38032 12.3909L9.71787 15.7554L17.6263 7.91037C17.854 7.68455 18.2216 7.686 18.4474 7.91366L18.8564 8.32592C19.0822 8.55358 19.0807 8.92123 18.8531 9.14705V9.14705Z' fill='%23C0BEC9'/%3E%3C/svg%3E%0A\");\n    background-repeat: no-repeat;\n    background-position: left top;\n    padding-left: ",
        ";\n\n    @media (min-width: ",
        ") {\n      background-position: left top 3px;\n    }\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  margin-top: 0;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n\n  ",
        " {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -45%);\n    z-index: -1;\n  }\n\n  li {\n    margin-bottom: 0;\n    background-image: unset;\n    padding-left: 0;\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: ",
        ";\n  margin-top: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.5;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}




var SuccessRate_styled_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e5f97d38-0"
})(SuccessRate_styled_templateObject(), (0,theme/* color */.$_)("indigo_100"), (0,theme/* color */.$_)("indigo_500"), (0,theme/* color */.$_)("white"), Typography/* Heading2 */.XJ, (0,theme/* color */.$_)("white"));
var SuccessRate_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e5f97d38-1"
})(SuccessRate_styled_templateObject1(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("xl5"), (0,theme/* spacing */.W0)("md"));
var SuccessRate_styled_StyledBillboard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e5f97d38-2"
})(SuccessRate_styled_templateObject2(), function() {
    return "url('".concat((0,paths/* getPublicPath */.A)("/images/stateOfHiring/pyramids.svg"), "'), linear-gradient(296.21deg, #b93a98 -56.41%, #472ca6 100%)");
}, (0,theme/* color */.$_)("white"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl2"), SuccessRate_styled_StyledContainer, (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* screen */.sp)("md"), (0,theme/* spacing */.W0)("xl6"), (0,theme/* spacing */.W0)("xl6"));
var SuccessRate_styled_StyledBillboardContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e5f97d38-3"
})(SuccessRate_styled_templateObject3());
var SuccessRate_styled_StyledBillboardTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Heading1 */.nL).withConfig({
    componentId: "sc-e5f97d38-4"
})(SuccessRate_styled_templateObject4(), (0,theme/* fontSize */.JB)("xl5"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("xl6"), (0,theme/* screen */.sp)("lg"), (0,theme/* fontSize */.JB)("xl7"));
var SuccessRate_styled_StyledHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e5f97d38-5"
})(SuccessRate_styled_templateObject5(), (0,theme/* container */.nC)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"));
var SuccessRate_styled_StyledCardTitle = styled_components_browser_esm/* default.h4.withConfig */.ZP.h4.withConfig({
    componentId: "sc-e5f97d38-6"
})(SuccessRate_styled_templateObject6(), (0,theme/* fontSize */.JB)("md"), (0,theme/* fontWeight */.Ue)("extraBold"), (0,theme/* color */.$_)("text_subtle"));
var StyledHighlightList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e5f97d38-7"
})(SuccessRate_styled_templateObject7(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* container */.nC)("lg"), SuccessRate_styled_StyledCardTitle);
var SuccessRate_styled_StyledHighlight = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e5f97d38-8"
})(SuccessRate_styled_templateObject8(), (0,theme/* color */.$_)("indigo_700"), (0,theme/* color */.$_)("white"), (0,theme/* spacing */.W0)("md"), (0,theme/* radius */.q0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("lg"));
var SuccessRate_styled_StyledHighlightValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e5f97d38-9"
})(SuccessRate_styled_templateObject9(), (0,theme/* fontFamily */.I8)("display"), (0,theme/* fontSize */.JB)("xl5"), (0,theme/* fontWeight */.Ue)("semiBold"));
var SuccessRate_styled_StyledContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e5f97d38-10"
})(SuccessRate_styled_templateObject10(), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* spacing */.W0)("xl"), SuccessRate_styled_StyledHighlight, StyledHighlightList, (0,theme/* spacing */.W0)("xs"), (0,theme/* screen */.sp)("md"), SuccessRate_styled_StyledHighlight);
var SuccessRate_styled_StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e5f97d38-11"
})(SuccessRate_styled_templateObject11(), (0,theme/* color */.$_)("white"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* radius */.q0)("lg"), (0,theme/* color */.$_)("text_default"));
var SuccessRate_styled_StyledDataItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e5f97d38-12"
})(SuccessRate_styled_templateObject12(), (0,theme/* spacing */.W0)("lg"), (0,theme/* fontWeight */.Ue)("extraBold"));
var SuccessRate_styled_StyledData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e5f97d38-13"
})(SuccessRate_styled_templateObject13(), (0,theme/* spacing */.W0)("xl"), (0,theme/* screen */.sp)("md"));
var SuccessRate_styled_StyledValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e5f97d38-14"
})(SuccessRate_styled_templateObject14(), (0,theme/* color */.$_)("indigo_500"), (0,theme/* fontSize */.JB)("lg"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xs"), (0,theme/* color */.$_)("indigo_300"), (0,theme/* spacing */.W0)("sm"));
var SuccessRate_styled_StyledValueNumber = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-e5f97d38-15"
})(SuccessRate_styled_templateObject15(), (0,theme/* fontFamily */.I8)("display"), (0,theme/* fontSize */.JB)("xl6"), (0,theme/* fontWeight */.Ue)("semiBold"));
var SuccessRate_styled_StyledSource = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e5f97d38-16"
})(SuccessRate_styled_templateObject16(), (0,theme/* fontSize */.JB)("xs"), (0,theme/* color */.$_)("text_subtle"), (0,theme/* spacing */.W0)("sm"), (0,theme/* fontWeight */.Ue)("extraBold"));
var StyledSatisfactionContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e5f97d38-17"
})(_templateObject17(), (0,theme/* container */.nC)("lg"), (0,theme/* spacing */.W0)("xl"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* screen */.sp)("md"), (0,theme/* fontSize */.JB)("lg"), Typography/* Heading2 */.XJ, (0,theme/* spacing */.W0)("lg"), (0,theme/* spacing */.W0)("xl2"), (0,theme/* screen */.sp)("md"));
var StyledNps = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e5f97d38-18"
})(_templateObject18());
var StyledNpsChart = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e5f97d38-19"
})(_templateObject19(), SuccessRate_styled_StyledValueNumber);
var StyledNpsItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e5f97d38-20"
})(_templateObject20(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("xl"), (0,theme/* fontSize */.JB)("md"));

;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/successRate/Rotation.tsx






var Rotation = function() {
    var t = (0,useI18n/* useI18n */.Q)("state-of-hiring").t;
    var rotationData = [
        {
            value: 4,
            desc: t("state-of-hiring.success-rate.rotation.replacement-rate")
        },
        {
            value: 15,
            desc: t("state-of-hiring.success-rate.rotation.rotation-average-manfred")
        },
        {
            value: 19,
            desc: t("state-of-hiring.success-rate.rotation.rotation-average-industry")
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessRate_styled_StyledWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuccessRate_styled_StyledContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessRate_styled_StyledHeader, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                        editorial: true,
                        children: t("state-of-hiring.success-rate.rotation.title")
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuccessRate_styled_StyledContent, {
                    className: "reverse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-lg",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                    i18nKey: "state-of-hiring.success-rate.rotation.content",
                                    ns: "state-of-hiring"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuccessRate_styled_StyledCard, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessRate_styled_StyledCardTitle, {
                                        children: t("state-of-hiring.success-rate.rotation.rol-title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_RotationRole, {})
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHighlightList, {
                    children: rotationData.map(function(item, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuccessRate_styled_StyledHighlight, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuccessRate_styled_StyledHighlightValue, {
                                    children: [
                                        item.value,
                                        "%"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: item.desc
                                })
                            ]
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuccessRate_styled_StyledSource, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("strong", {
                            children: [
                                "*",
                                t("state-of-hiring.success-rate.rotation.source"),
                                ":"
                            ]
                        }),
                        " ",
                        t("state-of-hiring.success-rate.rotation.source-name")
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var successRate_Rotation = (Rotation);

// EXTERNAL MODULE: ../../node_modules/recharts/es6/chart/PieChart.js
var PieChart = __webpack_require__(43454);
// EXTERNAL MODULE: ../../node_modules/recharts/es6/polar/Pie.js
var Pie = __webpack_require__(79941);
;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/charts/NPSCandidates.tsx




var NPSCandidates = function() {
    var locale = (0,router.useRouter)().locale;
    var GRAPH_12_NPS_CUSTOMERS = [
        {
            name: locale === "es" ? "Promotores" : "Promoters",
            value: 80
        },
        {
            name: locale === "es" ? "Pasivos" : "Passives",
            value: 15
        },
        {
            name: locale === "es" ? "Detractores" : "Detractors",
            value: 5
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PieChart/* PieChart */.u, {
                width: 170,
                height: 170,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Pie/* Pie */.b, {
                        data: GRAPH_12_NPS_CUSTOMERS,
                        labelLine: false,
                        innerRadius: 70,
                        outerRadius: 80,
                        dataKey: "value",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell/* Cell */.b, {
                                fill: "#78D549"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell/* Cell */.b, {
                                fill: "#DE9D1B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell/* Cell */.b, {
                                fill: "#DE492B"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                        cursor: {
                            fill: "transparent"
                        },
                        formatter: function(value) {
                            return value + "%";
                        }
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var charts_NPSCandidates = (NPSCandidates);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/charts/NPSClients.tsx




var NPSClients = function() {
    var locale = (0,router.useRouter)().locale;
    var GRAPH_12_NPS_CUSTOMERS = [
        {
            name: locale === "es" ? "Promotores" : "Promoters",
            value: 70
        },
        {
            name: locale === "es" ? "Pasivos" : "Passives",
            value: 20
        },
        {
            name: locale === "es" ? "Detractores" : "Detractors",
            value: 10
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PieChart/* PieChart */.u, {
                width: 170,
                height: 170,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Pie/* Pie */.b, {
                        data: GRAPH_12_NPS_CUSTOMERS,
                        labelLine: false,
                        innerRadius: 70,
                        outerRadius: 80,
                        dataKey: "value",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell/* Cell */.b, {
                                fill: "#78D549"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell/* Cell */.b, {
                                fill: "#DE9D1B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell/* Cell */.b, {
                                fill: "#DE492B"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                        cursor: {
                            fill: "transparent"
                        },
                        formatter: function(value) {
                            return value + "%";
                        }
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var charts_NPSClients = (NPSClients);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/charts/NPSCompanies.tsx




var NPSCompanies = function() {
    var locale = (0,router.useRouter)().locale;
    var GRAPH_12_NPS_CUSTOMERS = [
        {
            name: locale === "es" ? "Promotores" : "Promoters",
            value: 75
        },
        {
            name: locale === "es" ? "Pasivos" : "Passives",
            value: 22
        },
        {
            name: locale === "es" ? "Detractores" : "Detractors",
            value: 3
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PieChart/* PieChart */.u, {
                width: 170,
                height: 170,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Pie/* Pie */.b, {
                        data: GRAPH_12_NPS_CUSTOMERS,
                        labelLine: false,
                        innerRadius: 70,
                        outerRadius: 80,
                        dataKey: "value",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell/* Cell */.b, {
                                fill: "#78D549"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell/* Cell */.b, {
                                fill: "#DE9D1B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Cell/* Cell */.b, {
                                fill: "#DE492B"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                        cursor: {
                            fill: "transparent"
                        },
                        formatter: function(value) {
                            return value + "%";
                        }
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var charts_NPSCompanies = (NPSCompanies);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/successRate/Satisfaction.tsx








var Satisfaction = function() {
    var t = (0,useI18n/* useI18n */.Q)("state-of-hiring").t;
    var npsData = [
        {
            value: "8.66",
            desc: t("state-of-hiring.success-rate.satisfaction.nps-clients"),
            chart: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_NPSClients, {})
        },
        {
            value: "9.46",
            desc: t("state-of-hiring.success-rate.satisfaction.nps-candidates"),
            chart: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_NPSCandidates, {})
        },
        {
            value: "7.92",
            desc: t("state-of-hiring.success-rate.satisfaction.nps-companies"),
            chart: /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_NPSCompanies, {})
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessRate_styled_StyledContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSatisfactionContent, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessRate_styled_StyledHeader, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                                editorial: true,
                                alignLeft: true,
                                children: t("state-of-hiring.success-rate.satisfaction.title")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                            i18nKey: "state-of-hiring.success-rate.satisfaction.content",
                            ns: "state-of-hiring"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNps, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessRate_styled_StyledCardTitle, {
                            children: t("state-of-hiring.success-rate.satisfaction.nps-title")
                        }),
                        npsData.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNpsItem, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNpsChart, {
                                        children: [
                                            item.chart,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessRate_styled_StyledValueNumber, {
                                                children: item.value
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: item.desc
                                    })
                                ]
                            }, index);
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var successRate_Satisfaction = (Satisfaction);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/charts/SuccessRole.tsx




var SuccessRole = function() {
    var locale = (0,router.useRouter)().locale;
    var GRAPH_07_SUCCESS_BY_ROLE = [
        {
            label: locale === "es" ? "Liderazgo T\xe9cnico" : "Tech Lead",
            value: 76
        },
        {
            label: locale === "es" ? "Desarrollo Mobile" : "Mobile Development",
            value: 74
        },
        {
            label: locale === "es" ? "Desarrollo Backend" : "Backend Development",
            value: 72
        },
        {
            label: locale === "es" ? "Desarrollo Frontend" : "Frontend Development",
            value: 72
        },
        {
            label: locale === "es" ? "Infraestructura" : "Infraestructure",
            value: 64
        },
        {
            label: "Product Management",
            value: 63
        },
        {
            label: "Engineering Management",
            value: 55
        },
        {
            label: locale === "es" ? "Otros" : "Other",
            value: 54
        },
        {
            label: "QA & Testing",
            value: 54
        },
        {
            label: "Data",
            value: 52
        },
        {
            label: locale === "es" ? "Desarrollo Full-Stack" : "Full-Stack Development",
            value: 50
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                width: "99%",
                height: 360,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: GRAPH_07_SUCCESS_BY_ROLE,
                    layout: "vertical",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "number",
                            allowDecimals: false,
                            tickLine: false,
                            padding: {
                                left: 10
                            },
                            tickFormatter: function(tick) {
                                return tick + "%";
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "category",
                            dataKey: "label",
                            tickLine: false,
                            width: 190
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "#e6dfff"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: "",
                            formatter: function(value) {
                                return [
                                    value + "%",
                                    ""
                                ];
                            },
                            wrapperClassName: "tooltip-y"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "value",
                            fill: "#472CA6",
                            barSize: 12,
                            radius: 6
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_SuccessRole = (SuccessRole);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/charts/SuccessTech.tsx



var SuccessTech = function() {
    var GRAPH_08_SUCCESS_BY_TECH = [
        {
            label: "C#",
            value: 100,
            fill: "#472ca6"
        },
        {
            label: "Kubernetes",
            value: 100,
            fill: "#472ca6"
        },
        {
            label: ".NET",
            value: 94,
            fill: "#472ca6"
        },
        {
            label: "Android",
            value: 85,
            fill: "#472ca6"
        },
        {
            label: "Linux",
            value: 82,
            fill: "#472ca6"
        },
        {
            label: "Vue.JS",
            value: 81,
            fill: "#472ca6"
        },
        {
            label: "Angular",
            value: 80,
            fill: "#472ca6"
        },
        {
            label: "PHP",
            value: 80,
            fill: "#472ca6"
        },
        {
            label: "Kotlin",
            value: 78,
            fill: "#472ca6"
        },
        {
            label: "Java",
            value: 77,
            fill: "#472ca6"
        },
        {
            label: "Ruby",
            value: 77,
            fill: "#472ca6"
        },
        {
            label: "React",
            value: 73,
            fill: "#472ca6"
        },
        {
            label: "Docker",
            value: 70,
            fill: "#472ca6"
        },
        {
            label: "iOS",
            value: 67,
            fill: "#472ca6"
        },
        {
            label: "Node.js",
            value: 65,
            fill: "#472ca6"
        },
        {
            label: "JS",
            value: 65,
            fill: "#472ca6"
        },
        {
            label: "AWS",
            value: 64,
            fill: "#472ca6"
        },
        {
            label: "Go",
            value: 63,
            fill: "#472ca6"
        },
        {
            label: "Jenkins",
            value: 63,
            fill: "#472ca6"
        },
        {
            label: "Python",
            value: 56,
            fill: "#472ca6"
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRecharts, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* ResponsiveContainer */.h, {
                width: "99%",
                height: 400,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BarChart/* BarChart */.v, {
                    data: GRAPH_08_SUCCESS_BY_TECH,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(XAxis/* XAxis */.K, {
                            type: "category",
                            dataKey: "label",
                            tickLine: false,
                            interval: 0,
                            angle: -90,
                            textAnchor: "end",
                            height: 80,
                            dx: -5
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(YAxis/* YAxis */.B, {
                            type: "number",
                            allowDecimals: false,
                            padding: {
                                bottom: 5
                            },
                            tickLine: false,
                            width: 40,
                            tickFormatter: function(tick) {
                                return tick + "%";
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* Tooltip */.u, {
                            cursor: {
                                fill: "#e6dfff"
                            },
                            labelStyle: {
                                display: "none"
                            },
                            separator: "",
                            formatter: function(value) {
                                return [
                                    value + "%",
                                    ""
                                ];
                            },
                            wrapperClassName: "tooltip-x"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Bar/* Bar */.$, {
                            dataKey: "value",
                            fill: "#472CA6",
                            barSize: 12,
                            radius: 6
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var charts_SuccessTech = (SuccessTech);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/successRate/SuccessRateData.tsx







var SuccessRateData = function() {
    var t = (0,useI18n/* useI18n */.Q)("state-of-hiring").t;
    var locationData = [
        {
            value: 59,
            desc: t("state-of-hiring.success-rate.location.on-site")
        },
        {
            value: 74,
            desc: t("state-of-hiring.success-rate.location.remote")
        }
    ];
    var seniorityData = [
        {
            value: 75,
            desc: t("state-of-hiring.success-rate.seniority.senior")
        },
        {
            value: 75,
            desc: t("state-of-hiring.success-rate.seniority.mid-level")
        },
        {
            value: 87,
            desc: t("state-of-hiring.success-rate.seniority.junior")
        }
    ];
    var reasonsData = [
        {
            value: 30,
            desc: t("state-of-hiring.success-rate.reasons.on-hold")
        },
        {
            value: 20,
            desc: t("state-of-hiring.success-rate.reasons.external-reasons")
        },
        {
            value: 16,
            desc: t("state-of-hiring.success-rate.reasons.no-value")
        },
        {
            value: 10,
            desc: t("state-of-hiring.success-rate.reasons.internal-hire")
        },
        {
            value: 7,
            desc: t("state-of-hiring.success-rate.reasons.no-need")
        },
        {
            value: 7,
            desc: t("state-of-hiring.success-rate.reasons.other-person")
        },
        {
            value: 4,
            desc: t("state-of-hiring.success-rate.reasons.no-understanding")
        },
        {
            value: 2,
            desc: t("state-of-hiring.success-rate.reasons.no-answer")
        },
        {
            value: 1,
            desc: t("state-of-hiring.success-rate.reasons.other-agency")
        },
        {
            value: 1,
            desc: t("state-of-hiring.success-rate.reasons.too-expensive")
        },
        {
            value: 1,
            desc: t("state-of-hiring.success-rate.reasons.candidate-rejection")
        },
        {
            value: 1,
            desc: t("state-of-hiring.success-rate.reasons.closed-position")
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessRate_styled_StyledWrapper, {
        className: "notice",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuccessRate_styled_StyledContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuccessRate_styled_StyledHeader, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                            editorial: true,
                            children: t("state-of-hiring.success-rate.title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlTrans/* default */.Z, {
                                i18nKey: "state-of-hiring.success-rate.desc",
                                ns: "state-of-hiring"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuccessRate_styled_StyledContent, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuccessRate_styled_StyledCard, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessRate_styled_StyledCardTitle, {
                                        children: t("state-of-hiring.success-rate.rol.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_SuccessRole, {})
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHighlightList, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuccessRate_styled_StyledHighlight, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessRate_styled_StyledHighlightValue, {
                                                    children: "72%"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: t("state-of-hiring.success-rate.manfred")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuccessRate_styled_StyledHighlight, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessRate_styled_StyledHighlightValue, {
                                                    children: "72%"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: t("state-of-hiring.success-rate.recurrent")
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuccessRate_styled_StyledCard, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessRate_styled_StyledCardTitle, {
                                            children: t("state-of-hiring.success-rate.location.title")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessRate_styled_StyledData, {
                                            children: locationData.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuccessRate_styled_StyledDataItem, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessRate_styled_StyledValue, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuccessRate_styled_StyledValueNumber, {
                                                                children: [
                                                                    item.value,
                                                                    "%"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: item.desc
                                                        })
                                                    ]
                                                }, index);
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuccessRate_styled_StyledContent, {
                    className: "reverse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuccessRate_styled_StyledCard, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessRate_styled_StyledCardTitle, {
                                            children: t("state-of-hiring.success-rate.seniority.title")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessRate_styled_StyledData, {
                                            children: seniorityData.map(function(item, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuccessRate_styled_StyledDataItem, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessRate_styled_StyledValue, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuccessRate_styled_StyledValueNumber, {
                                                                children: [
                                                                    item.value,
                                                                    "%"
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: item.desc
                                                        })
                                                    ]
                                                }, index);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuccessRate_styled_StyledHighlight, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessRate_styled_StyledHighlightValue, {
                                            children: "4%"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: t("state-of-hiring.success-rate.rejections")
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuccessRate_styled_StyledCard, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessRate_styled_StyledCardTitle, {
                                        children: t("state-of-hiring.success-rate.tech.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(charts_SuccessTech, {})
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHighlightList, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessRate_styled_StyledCardTitle, {
                            children: t("state-of-hiring.success-rate.reasons.title")
                        }),
                        reasonsData.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuccessRate_styled_StyledHighlight, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuccessRate_styled_StyledHighlightValue, {
                                        children: [
                                            item.value,
                                            "%"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: item.desc
                                    })
                                ]
                            }, index);
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var successRate_SuccessRateData = (SuccessRateData);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/components/successRate/SuccessRate.tsx






var SuccessRate = function() {
    var t = (0,useI18n/* useI18n */.Q)("state-of-hiring").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessRate_styled_StyledBillboard, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessRate_styled_StyledContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SuccessRate_styled_StyledBillboardContent, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SuccessRate_styled_StyledBillboardTitle, {
                                as: "p",
                                children: t("state-of-hiring.success-rate.billboard-title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: t("state-of-hiring.success-rate.billboard-desc")
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(successRate_SuccessRateData, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(successRate_Satisfaction, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(successRate_Rotation, {})
        ]
    });
};
/* harmony default export */ var successRate_SuccessRate = (SuccessRate);

;// CONCATENATED MODULE: ./components/marketingSite/stateOfHiring/StateOfHiringComponent.tsx










var StateOfHiringComponent = function() {
    //const { locale } = useRouter();
    var t = (0,useI18n/* useI18n */.Q)("state-of-hiring").t;
    var sections = [
        {
            section: "intro",
            tooltip: t("state-of-hiring.nav.intro")
        },
        {
            section: "duration-and-costs",
            tooltip: t("state-of-hiring.nav.time-to-hire")
        },
        {
            section: "success-rate",
            tooltip: t("state-of-hiring.nav.success-rate")
        },
        {
            section: "candidates",
            tooltip: t("state-of-hiring.nav.candidates")
        },
        {
            section: "methodology",
            tooltip: t("state-of-hiring.nav.methodology")
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.ZP, {
        pageVariant: "light",
        hasScrollTop: true,
        sections: sections,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_StateOfHiringHero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                name: "intro",
                id: "intro",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(intro_StateOfHiringIntro, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                name: "duration-and-costs",
                id: "duration-and-costs",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(durationAndCosts_DurationAndCosts, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                name: "success-rate",
                id: "success-rate",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(successRate_SuccessRate, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                name: "candidates",
                id: "candidates",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(candidates_Candidates, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                name: "methodology",
                id: "methodology",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(methodology_Methodology, {})
            })
        ]
    });
};
/* harmony default export */ var stateOfHiring_StateOfHiringComponent = (StateOfHiringComponent);

// EXTERNAL MODULE: ./components/shared/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(73412);
// EXTERNAL MODULE: ./hooks/usePageTrack/index.ts + 1 modules
var usePageTrack = __webpack_require__(56002);
;// CONCATENATED MODULE: ./pages/state-of-hiring.tsx







var StateOfHiringPage = function(param) {
    var baseUrl = param.baseUrl;
    var t = (0,useI18n/* useI18n */.Q)("state-of-hiring").t;
    (0,usePageTrack/* usePageTrack */.N)("Landing - Page Loaded");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                title: t("state-of-hiring.page_title"),
                url: app_urls/* APP_URLS.stateOfHiring */.uu.stateOfHiring,
                desc: t("state-of-hiring.page_description"),
                imgUrl: "".concat(baseUrl).concat((0,paths/* getPublicPath */.A)("/images/cards/card_state_of_hiring.png"))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(stateOfHiring_StateOfHiringComponent, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var state_of_hiring = (StateOfHiringPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,8746,9001,2077,3004,1601,9161,9092,9774,2888,179], function() { return __webpack_exec__(76896); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);